"use strict";

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var Paper = _interopDefault(require("@material-ui/core/Paper")),
    styles = require("@material-ui/core/styles"),
    MuiTable = _interopDefault(require("@material-ui/core/Table")),
    clsx = _interopDefault(require("clsx")),
    assignwith = _interopDefault(require("lodash.assignwith")),
    cloneDeep = _interopDefault(require("lodash.clonedeep")),
    find = _interopDefault(require("lodash.find")),
    isEqual = _interopDefault(require("lodash.isequal")),
    isUndefined = _interopDefault(require("lodash.isundefined")),
    merge = _interopDefault(require("lodash.merge"));

require("prop-types");

var React = require("react"),
    React__default = _interopDefault(React),
    Typography = _interopDefault(require("@material-ui/core/Typography")),
    MuiTableBody = _interopDefault(require("@material-ui/core/TableBody")),
    TableCell = _interopDefault(require("@material-ui/core/TableCell")),
    TableRow = _interopDefault(require("@material-ui/core/TableRow")),
    Checkbox = _interopDefault(require("@material-ui/core/Checkbox")),
    IconButton = _interopDefault(require("@material-ui/core/IconButton")),
    Remove = _interopDefault(require("@material-ui/icons/Remove")),
    KeyboardArrowRight = _interopDefault(require("@material-ui/icons/KeyboardArrowRight")),
    core = require("@material-ui/core"),
    Button = _interopDefault(require("@material-ui/core/Button")),
    FormControl = _interopDefault(require("@material-ui/core/FormControl")),
    FormControlLabel = _interopDefault(require("@material-ui/core/FormControlLabel")),
    FormGroup = _interopDefault(require("@material-ui/core/FormGroup")),
    Input = _interopDefault(require("@material-ui/core/Input")),
    InputLabel = _interopDefault(require("@material-ui/core/InputLabel")),
    ListItemText = _interopDefault(require("@material-ui/core/ListItemText")),
    MenuItem = _interopDefault(require("@material-ui/core/MenuItem")),
    Select = _interopDefault(require("@material-ui/core/Select")),
    Chip = _interopDefault(require("@material-ui/core/Chip")),
    MuiTableFooter = _interopDefault(require("@material-ui/core/TableFooter")),
    MuiTablePagination = _interopDefault(require("@material-ui/core/TablePagination")),
    MuiTableHead = _interopDefault(require("@material-ui/core/TableHead")),
    HelpIcon = _interopDefault(require("@material-ui/icons/Help")),
    MuiTooltip = _interopDefault(require("@material-ui/core/Tooltip")),
    TableSortLabel = _interopDefault(require("@material-ui/core/TableSortLabel")),
    reactDnd = require("react-dnd"),
    Toolbar = _interopDefault(require("@material-ui/core/Toolbar")),
    MuiPopover = _interopDefault(require("@material-ui/core/Popover")),
    CloseIcon = _interopDefault(require("@material-ui/icons/Close")),
    Grow = _interopDefault(require("@material-ui/core/Grow")),
    TextField = _interopDefault(require("@material-ui/core/TextField")),
    SearchIcon = _interopDefault(require("@material-ui/icons/Search")),
    ClearIcon = _interopDefault(require("@material-ui/icons/Clear")),
    DownloadIcon = _interopDefault(require("@material-ui/icons/CloudDownload")),
    PrintIcon = _interopDefault(require("@material-ui/icons/Print")),
    ViewColumnIcon = _interopDefault(require("@material-ui/icons/ViewColumn")),
    FilterIcon = _interopDefault(require("@material-ui/icons/FilterList")),
    ReactToPrint = _interopDefault(require("react-to-print")),
    DeleteIcon = _interopDefault(require("@material-ui/icons/Delete")),
    reactDndHtml5Backend = require("react-dnd-html5-backend");

function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, t) {
  for (var a = 0; a < t.length; a++) {
    var o = t[a];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}

function _createClass(e, t, a) {
  return t && _defineProperties(e.prototype, t), a && _defineProperties(e, a), e;
}

function _defineProperty(e, t, a) {
  return t in e ? Object.defineProperty(e, t, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = a, e;
}

function _extends() {
  return (_extends = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var o in a) {
        Object.prototype.hasOwnProperty.call(a, o) && (e[o] = a[o]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function ownKeys(t, e) {
  var a,
      o = Object.keys(t);
  return Object.getOwnPropertySymbols && (a = Object.getOwnPropertySymbols(t), e && (a = a.filter(function (e) {
    return Object.getOwnPropertyDescriptor(t, e).enumerable;
  })), o.push.apply(o, a)), o;
}

function _objectSpread2(t) {
  for (var e = 1; e < arguments.length; e++) {
    var a = null != arguments[e] ? arguments[e] : {};
    e % 2 ? ownKeys(Object(a), !0).forEach(function (e) {
      _defineProperty(t, e, a[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : ownKeys(Object(a)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(a, e));
    });
  }

  return t;
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && _setPrototypeOf(e, t);
}

function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function _setPrototypeOf(e, t) {
  return (_setPrototypeOf = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

function _objectWithoutPropertiesLoose(e, t) {
  if (null == e) return {};

  for (var a, o = {}, n = Object.keys(e), r = 0; r < n.length; r++) {
    a = n[r], 0 <= t.indexOf(a) || (o[a] = e[a]);
  }

  return o;
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};

  var a,
      o = _objectWithoutPropertiesLoose(e, t);

  if (Object.getOwnPropertySymbols) for (var n = Object.getOwnPropertySymbols(e), r = 0; r < n.length; r++) {
    a = n[r], 0 <= t.indexOf(a) || Object.prototype.propertyIsEnumerable.call(e, a) && (o[a] = e[a]);
  }
  return o;
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? _assertThisInitialized(e) : t;
}

function _createSuper(a) {
  var o = _isNativeReflectConstruct();

  return function () {
    var e,
        t = _getPrototypeOf(a);

    return _possibleConstructorReturn(this, o ? (e = _getPrototypeOf(this).constructor, Reflect.construct(t, arguments, e)) : t.apply(this, arguments));
  };
}

function _slicedToArray(e, t) {
  return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _unsupportedIterableToArray(e, t) || _nonIterableRest();
}

function _toConsumableArray(e) {
  return _arrayWithoutHoles(e) || _iterableToArray(e) || _unsupportedIterableToArray(e) || _nonIterableSpread();
}

function _arrayWithoutHoles(e) {
  if (Array.isArray(e)) return _arrayLikeToArray(e);
}

function _arrayWithHoles(e) {
  if (Array.isArray(e)) return e;
}

function _iterableToArray(e) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
}

function _iterableToArrayLimit(e, t) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
    var a = [],
        o = !0,
        n = !1,
        r = void 0;

    try {
      for (var i, l = e[Symbol.iterator](); !(o = (i = l.next()).done) && (a.push(i.value), !t || a.length !== t); o = !0) {
        ;
      }
    } catch (e) {
      n = !0, r = e;
    } finally {
      try {
        o || null == l.return || l.return();
      } finally {
        if (n) throw r;
      }
    }

    return a;
  }
}

function _unsupportedIterableToArray(e, t) {
  if (e) {
    if ("string" == typeof e) return _arrayLikeToArray(e, t);
    var a = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? Array.from(e) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? _arrayLikeToArray(e, t) : void 0;
  }
}

function _arrayLikeToArray(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var a = 0, o = new Array(t); a < t; a++) {
    o[a] = e[a];
  }

  return o;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var useStyles = styles.makeStyles(function (e) {
  return {
    root: {},
    cellHide: {
      display: "none"
    },
    simpleHeader: _defineProperty({}, e.breakpoints.down("xs"), {
      display: "inline-block",
      fontWeight: "bold",
      width: "100%",
      boxSizing: "border-box"
    }),
    simpleCell: _defineProperty({}, e.breakpoints.down("xs"), {
      display: "inline-block",
      width: "100%",
      boxSizing: "border-box"
    }),
    stackedHeader: {
      verticalAlign: "top"
    },
    stackedCommon: _defineProperty({}, e.breakpoints.down("sm"), {
      display: "inline-block",
      fontSize: "16px",
      height: "auto",
      width: "calc(50%)",
      boxSizing: "border-box",
      "&:last-child": {
        borderBottom: "none"
      },
      "&:nth-last-child(2)": {
        borderBottom: "none"
      }
    }),
    stackedCommonAlways: {
      display: "inline-block",
      fontSize: "16px",
      height: "auto",
      width: "calc(50%)",
      boxSizing: "border-box",
      "&:last-child": {
        borderBottom: "none"
      },
      "&:nth-last-child(2)": {
        borderBottom: "none"
      }
    },
    stackedParent: _defineProperty({}, e.breakpoints.down("sm"), {
      display: "inline-block",
      fontSize: "16px",
      height: "auto",
      width: "calc(100%)",
      boxSizing: "border-box"
    }),
    stackedParentAlways: {
      display: "inline-block",
      fontSize: "16px",
      height: "auto",
      width: "calc(100%)",
      boxSizing: "border-box"
    },
    cellStackedSmall: _defineProperty({}, e.breakpoints.down("sm"), {
      width: "50%",
      boxSizing: "border-box"
    }),
    responsiveStackedSmall: _defineProperty({}, e.breakpoints.down("sm"), {
      width: "50%",
      boxSizing: "border-box"
    }),
    responsiveStackedSmallParent: _defineProperty({}, e.breakpoints.down("sm"), {
      width: "100%",
      boxSizing: "border-box"
    })
  };
}, {
  name: "MUIDataTableBodyCell"
});

function TableBodyCell(e) {
  var t,
      a,
      o,
      n = useStyles(),
      r = e.children,
      i = e.colIndex,
      l = e.columnHeader,
      s = e.options,
      c = e.dataIndex,
      d = e.rowIndex,
      p = e.className,
      u = e.print,
      f = e.tableId,
      h = _objectWithoutProperties(e, ["children", "colIndex", "columnHeader", "options", "dataIndex", "rowIndex", "className", "print", "tableId"]),
      m = s.onCellClick,
      b = React.useCallback(function (e) {
    m(r, {
      colIndex: i,
      rowIndex: d,
      dataIndex: c,
      event: e
    });
  }, [m, r, i, d, c]),
      y = {};

  m && (y.onClick = b);
  var _ = [React__default.createElement("div", {
    key: 1,
    className: clsx((_defineProperty(t = {
      lastColumn: 2 === i
    }, n.root, !0), _defineProperty(t, n.cellHide, !0), _defineProperty(t, n.stackedHeader, !0), _defineProperty(t, n.stackedCommon, "vertical" === s.responsive || "stacked" === s.responsive || "stackedFullWidth" === s.responsive), _defineProperty(t, n.stackedCommonAlways, "verticalAlways" === s.responsive), _defineProperty(t, n.cellStackedSmall, "stacked" === s.responsive || "stackedFullWidth" === s.responsive && ("none" === s.setTableProps().padding || "small" === s.setTableProps().size)), _defineProperty(t, n.simpleHeader, "simple" === s.responsive), _defineProperty(t, "datatables-noprint", !u), t), p)
  }, l), React__default.createElement("div", {
    key: 2,
    className: clsx((_defineProperty(a = {}, n.root, !0), _defineProperty(a, n.stackedCommon, "vertical" === s.responsive || "stacked" === s.responsive || "stackedFullWidth" === s.responsive), _defineProperty(a, n.stackedCommonAlways, "verticalAlways" === s.responsive), _defineProperty(a, n.responsiveStackedSmall, "stacked" === s.responsive || "stackedFullWidth" === s.responsive && ("none" === s.setTableProps().padding || "small" === s.setTableProps().size)), _defineProperty(a, n.simpleCell, "simple" === s.responsive), _defineProperty(a, "datatables-noprint", !u), a), p)
  }, "function" == typeof r ? r(c, d) : r)],
      g = -1 !== ["standard", "scrollMaxHeight", "scrollFullHeight", "scrollFullHeightFullWidth"].indexOf(s.responsive) ? _.slice(1, 2) : _;
  return React__default.createElement(TableCell, _extends({}, y, {
    "data-colindex": i,
    "data-tableid": f,
    className: clsx((_defineProperty(o = {}, n.root, !0), _defineProperty(o, n.stackedParent, "vertical" === s.responsive || "stacked" === s.responsive || "stackedFullWidth" === s.responsive), _defineProperty(o, n.stackedParentAlways, "verticalAlways" === s.responsive), _defineProperty(o, n.responsiveStackedSmallParent, "vertical" === s.responsive || "stacked" === s.responsive || "stackedFullWidth" === s.responsive && ("none" === s.setTableProps().padding || "small" === s.setTableProps().size)), _defineProperty(o, n.simpleCell, "simple" === s.responsive), _defineProperty(o, "datatables-noprint", !u), o), p)
  }, h), g);
}

var defaultBodyRowStyles = function defaultBodyRowStyles(e) {
  return {
    root: {
      "&.Mui-selected": {
        backgroundColor: e.palette.action.selected
      },
      "&.mui-row-selected": {
        backgroundColor: e.palette.action.selected
      }
    },
    hoverCursor: {
      cursor: "pointer"
    },
    responsiveStacked: _defineProperty({}, e.breakpoints.down("sm"), {
      borderTop: "solid 2px rgba(0, 0, 0, 0.15)",
      borderBottom: "solid 2px rgba(0, 0, 0, 0.15)",
      padding: 0,
      margin: 0
    }),
    responsiveSimple: _defineProperty({}, e.breakpoints.down("xs"), {
      borderTop: "solid 2px rgba(0, 0, 0, 0.15)",
      borderBottom: "solid 2px rgba(0, 0, 0, 0.15)",
      padding: 0,
      margin: 0
    })
  };
},
    TableBodyRow = function () {
  _inherits(t, React__default.Component);

  var e = _createSuper(t);

  function t() {
    return _classCallCheck(this, t), e.apply(this, arguments);
  }

  return _createClass(t, [{
    key: "render",
    value: function value() {
      var e,
          t = this.props,
          a = t.classes,
          o = t.options,
          n = t.rowSelected,
          r = t.onClick,
          i = t.className,
          l = t.isRowSelectable,
          s = _objectWithoutProperties(t, ["classes", "options", "rowSelected", "onClick", "className", "isRowSelectable"]),
          c = {};

      return r && (c.onClick = r), React__default.createElement(TableRow, _extends({
        hover: !!o.rowHover
      }, c, {
        className: clsx((_defineProperty(e = {}, a.root, !0), _defineProperty(e, a.hover, o.rowHover), _defineProperty(e, a.hoverCursor, o.selectableRowsOnClick && l || o.expandableRowsOnClick), _defineProperty(e, a.responsiveSimple, "simple" === o.responsive), _defineProperty(e, a.responsiveStacked, "vertical" === o.responsive || "stacked" === o.responsive || "stackedFullWidth" === o.responsive), _defineProperty(e, "mui-row-selected", n), e), i),
        selected: n
      }, s), this.props.children);
    }
  }]), t;
}(),
    TableBodyRow$1 = styles.withStyles(defaultBodyRowStyles, {
  name: "MUIDataTableBodyRow"
})(TableBodyRow);

function ExpandButton(e) {
  return React__default.createElement(React__default.Fragment, null, e.isHeaderCell && !e.areAllRowsExpanded() && e.expandedRows && 0 < e.expandedRows.data.length ? React__default.createElement(IconButton, {
    onClick: e.onExpand,
    style: {
      padding: 0
    },
    disabled: !1 === e.expandableRowsHeader,
    className: e.buttonClass
  }, React__default.createElement(Remove, {
    id: "expandable-button",
    className: e.iconIndeterminateClass
  })) : React__default.createElement(IconButton, {
    onClick: e.onExpand,
    style: {
      padding: 0
    },
    disabled: !1 === e.expandableRowsHeader,
    className: e.buttonClass
  }, React__default.createElement(KeyboardArrowRight, {
    id: "expandable-button",
    className: e.iconClass
  })));
}

var defaultSelectCellStyles = function defaultSelectCellStyles(e) {
  return {
    root: {
      "@media print": {
        display: "none"
      }
    },
    fixedHeader: {
      position: "sticky",
      top: "0px",
      zIndex: 100
    },
    fixedLeft: {
      position: "sticky",
      left: "0px",
      zIndex: 100
    },
    icon: {
      cursor: "pointer",
      transition: "transform 0.25s"
    },
    expanded: {
      transform: "rotate(90deg)"
    },
    hide: {
      visibility: "hidden"
    },
    headerCell: {
      zIndex: 110,
      backgroundColor: e.palette.background.paper
    },
    expandDisabled: {},
    checkboxRoot: {},
    checked: {},
    disabled: {}
  };
},
    TableSelectCell = function () {
  _inherits(t, React__default.Component);

  var e = _createSuper(t);

  function t() {
    return _classCallCheck(this, t), e.apply(this, arguments);
  }

  return _createClass(t, [{
    key: "render",
    value: function value() {
      var e,
          t,
          a,
          o = this.props,
          n = o.classes,
          r = o.fixedHeader,
          i = o.fixedSelectColumn,
          l = o.isHeaderCell,
          s = o.expandableOn,
          c = o.selectableOn,
          d = o.isRowExpanded,
          p = o.onExpand,
          u = o.isRowSelectable,
          f = o.selectableRowsHeader,
          h = o.hideExpandButton,
          m = o.expandableRowsHeader,
          b = o.expandedRows,
          y = o.areAllRowsExpanded,
          _ = void 0 === y ? function () {
        return !1;
      } : y,
          g = o.selectableRowsHideCheckboxes,
          x = o.setHeadCellRef,
          v = o.dataIndex,
          R = o.components,
          w = void 0 === R ? {} : R,
          T = _objectWithoutProperties(o, ["classes", "fixedHeader", "fixedSelectColumn", "isHeaderCell", "expandableOn", "selectableOn", "isRowExpanded", "onExpand", "isRowSelectable", "selectableRowsHeader", "hideExpandButton", "expandableRowsHeader", "expandedRows", "areAllRowsExpanded", "selectableRowsHideCheckboxes", "setHeadCellRef", "dataIndex", "components"]);

      if (!s && "none" === c) return !1;
      var C = w.Checkbox || Checkbox,
          S = w.ExpandButton || ExpandButton,
          P = clsx((_defineProperty(e = {}, n.root, !0), _defineProperty(e, n.fixedHeader, r && l), _defineProperty(e, n.fixedLeft, i), _defineProperty(e, n.headerCell, l), e)),
          I = clsx(_defineProperty({}, n.expandDisabled, h)),
          k = clsx((_defineProperty(t = {}, n.icon, !0), _defineProperty(t, n.hide, l && !m), _defineProperty(t, n.expanded, d || l && _()), t)),
          D = clsx((_defineProperty(a = {}, n.icon, !0), _defineProperty(a, n.hide, l && !m), a)),
          E = {};
      x && (E.ref = function (e) {
        x(0, 0, e);
      });
      return React__default.createElement(TableCell, _extends({
        className: P,
        padding: "checkbox"
      }, E), React__default.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center"
        }
      }, s && React__default.createElement(S, {
        isHeaderCell: l,
        areAllRowsExpanded: _,
        expandedRows: b,
        onExpand: p,
        expandableRowsHeader: m,
        buttonClass: I,
        iconIndeterminateClass: D,
        iconClass: k,
        dataIndex: v
      }), "none" !== c && !0 !== g && (!l || "multiple" === c && !1 !== f ? React__default.createElement(C, _extends({
        classes: {
          root: n.checkboxRoot,
          checked: n.checked,
          disabled: n.disabled
        },
        "data-description": l ? "row-select-header" : "row-select",
        "data-index": v || null,
        color: "primary",
        disabled: !u
      }, T)) : null)));
    }
  }]), t;
}();

_defineProperty(TableSelectCell, "defaultProps", {
  isHeaderCell: !1,
  isRowExpanded: !1,
  expandableOn: !1,
  selectableOn: "none"
});

var TableSelectCell$1 = styles.withStyles(defaultSelectCellStyles, {
  name: "MUIDataTableSelectCell"
})(TableSelectCell);

function buildMap(e) {
  return e.reduce(function (e, t) {
    return e[t.dataIndex] = !0, e;
  }, {});
}

function escapeDangerousCSVCharacters(e) {
  return "string" == typeof e ? e.replace(/^\+|^\-|^\=|^\@/g, "'$&") : e;
}

function warnDeprecated(e) {
  var t = !(1 < arguments.length && void 0 !== arguments[1]) || arguments[1],
      a = "function" == typeof t ? t : console.warn;
  t && a("Deprecation Notice:  ".concat(e));
}

function warnInfo(e) {
  var t = !(1 < arguments.length && void 0 !== arguments[1]) || arguments[1],
      a = "function" == typeof t ? t : console.warn;
  t && a("".concat(e));
}

function getPageValue(e, t, a) {
  var o = e <= t ? 1 : Math.ceil(e / t);
  return o <= a ? o - 1 : a;
}

function getCollatorComparator() {
  if (Intl) return new Intl.Collator(void 0, {
    numeric: !0,
    sensitivity: "base"
  }).compare;
  return function (e, t) {
    return e.localeCompare(t);
  };
}

function sortCompare(n) {
  return function (e, t) {
    var a = null === e.data || void 0 === e.data ? "" : e.data,
        o = null === t.data || void 0 === t.data ? "" : t.data;
    return ("function" == typeof a.localeCompare ? a.localeCompare(o) : a - o) * ("asc" === n ? 1 : -1);
  };
}

function buildCSV(a, e, o) {
  function n(e) {
    return "string" == typeof e ? e.replace(/\"/g, '""') : e;
  }

  function t(e) {
    return e.reduce(function (e, t) {
      return t.download ? e + '"' + escapeDangerousCSVCharacters(n(t.label || t.name)) + '"' + o.downloadOptions.separator : e;
    }, "").slice(0, -1) + "\r\n";
  }

  function r(e) {
    return e.length ? e.reduce(function (e, t) {
      return e + '"' + t.data.filter(function (e, t) {
        return a[t].download;
      }).map(function (e) {
        return escapeDangerousCSVCharacters(n(e));
      }).join('"' + o.downloadOptions.separator + '"') + '"\r\n';
    }, "").trim() : "";
  }

  var i = t(a),
      l = r(e);
  return o.onDownload ? o.onDownload(t, r, a, e) : "".concat(i).concat(l).trim();
}

function downloadCSV(e, t) {
  var a,
      o,
      n,
      r,
      i = new Blob([e], {
    type: "text/csv"
  });
  navigator && navigator.msSaveOrOpenBlob ? navigator.msSaveOrOpenBlob(i, t) : (a = "data:text/csv;charset=utf-8,".concat(e), n = void 0 === (o = window.URL || window.webkitURL).createObjectURL ? a : o.createObjectURL(i), (r = document.createElement("a")).setAttribute("href", n), r.setAttribute("download", t), document.body.appendChild(r), r.click(), document.body.removeChild(r));
}

function createCSVDownload(e, t, a, o) {
  var n = buildCSV(e, t, a);
  a.onDownload && !1 === n || o(n, a.downloadOptions.filename);
}

var defaultBodyStyles = function defaultBodyStyles(e) {
  return {
    root: {},
    emptyTitle: {
      textAlign: "center"
    },
    lastStackedCell: _defineProperty({}, e.breakpoints.down("sm"), {
      "& td:last-child": {
        borderBottom: "none"
      }
    }),
    lastSimpleCell: _defineProperty({}, e.breakpoints.down("xs"), {
      "& td:last-child": {
        borderBottom: "none"
      }
    })
  };
},
    TableBody = function () {
  _inherits(n, React__default.Component);

  var o = _createSuper(n);

  function n() {
    var s;

    _classCallCheck(this, n);

    for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
      t[a] = arguments[a];
    }

    return _defineProperty(_assertThisInitialized(s = o.call.apply(o, [this].concat(t))), "handleRowSelect", function (a, e) {
      var t = !(!e || !e.nativeEvent) && e.nativeEvent.shiftKey,
          o = [],
          n = s.props.previousSelectedRow;

      if (t && n && n.index < s.props.data.length) {
        var r = n.index,
            i = cloneDeep(s.props.selectedRows),
            l = s.props.data[a.index].dataIndex;
        0 === i.data.filter(function (e) {
          return e.dataIndex === l;
        }).length && (i.data.push({
          index: a.index,
          dataIndex: l
        }), i.lookup[l] = !0);

        for (; r !== a.index;) {
          !function () {
            var e,
                t = s.props.data[r].dataIndex;
            s.isRowSelectable(t, i) && (e = {
              index: r,
              dataIndex: t
            }, 0 === i.data.filter(function (e) {
              return e.dataIndex === t;
            }).length && (i.data.push(e), i.lookup[t] = !0), o.push(e)), r = a.index > r ? r + 1 : r - 1;
          }();
        }
      }

      s.props.selectRowUpdate("cell", a, o);
    }), _defineProperty(_assertThisInitialized(s), "handleRowClick", function (e, t, a) {
      var o, n;
      "expandable-button" === a.target.id || "path" === a.target.nodeName && "expandable-button" === a.target.parentNode.id || a.target.id && a.target.id.startsWith("MUIDataTableSelectCell") || (s.props.options.selectableRowsOnClick && "none" !== s.props.options.selectableRows && s.isRowSelectable(t.dataIndex, s.props.selectedRows) && (o = {
        index: t.rowIndex,
        dataIndex: t.dataIndex
      }, s.handleRowSelect(o, a)), s.props.options.expandableRowsOnClick && s.props.options.expandableRows && s.isRowExpandable(t.dataIndex, s.props.expandedRows) && (n = {
        index: t.rowIndex,
        dataIndex: t.dataIndex
      }, s.props.toggleExpandRow(n)), s.props.options.selectableRowsOnClick || s.props.options.onRowClick && s.props.options.onRowClick(e, t, a));
    }), _defineProperty(_assertThisInitialized(s), "processRow", function (e, t) {
      for (var a = [], o = 0; o < e.length; o++) {
        a.push({
          value: e[t[o]],
          index: t[o]
        });
      }

      return a;
    }), s;
  }

  return _createClass(n, [{
    key: "buildRows",
    value: function value() {
      var e = this.props,
          t = e.data,
          a = e.page,
          o = e.rowsPerPage,
          n = e.count;
      if (this.props.options.serverSide) return t.length ? t : null;
      var r = [],
          i = getPageValue(n, o, a),
          l = 0 === i ? 0 : i * o,
          s = Math.min(n, (i + 1) * o);
      i < a && console.warn("Current page is out of range, using the highest page that is in range instead.");

      for (var c = l; c < n && c < s; c++) {
        void 0 !== t[c] && r.push(t[c]);
      }

      return r.length ? r : null;
    }
  }, {
    key: "getRowIndex",
    value: function value(e) {
      var t = this.props,
          a = t.page,
          o = t.rowsPerPage;
      return t.options.serverSide ? e : (0 === a ? 0 : a * o) + e;
    }
  }, {
    key: "isRowSelected",
    value: function value(e) {
      var t = this.props.selectedRows;
      return !(!t.lookup || !t.lookup[e]);
    }
  }, {
    key: "isRowExpanded",
    value: function value(e) {
      var t = this.props.expandedRows;
      return !(!t.lookup || !t.lookup[e]);
    }
  }, {
    key: "isRowSelectable",
    value: function value(e, t) {
      var a = this.props.options;
      return t = t || this.props.selectedRows, !a.isRowSelectable || a.isRowSelectable(e, t);
    }
  }, {
    key: "isRowExpandable",
    value: function value(e) {
      var t = this.props,
          a = t.options,
          o = t.expandedRows;
      return !a.isRowExpandable || a.isRowExpandable(e, o);
    }
  }, {
    key: "render",
    value: function value() {
      var c = this,
          e = this.props,
          d = e.classes,
          p = e.columns,
          u = e.toggleExpandRow,
          f = e.options,
          t = e.columnOrder,
          h = void 0 === t ? this.props.columns.map(function (e, t) {
        return t;
      }) : t,
          a = e.components,
          m = void 0 === a ? {} : a,
          b = e.tableId,
          o = this.buildRows(),
          n = p.filter(function (e) {
        return "true" === e.display;
      }).length;
      return React__default.createElement(MuiTableBody, null, o && 0 < o.length ? o.map(function (e, t) {
        var a,
            o = e.data,
            n = e.dataIndex;
        if (f.customRowRender) return f.customRowRender(o, n, t);
        var r = "none" !== f.selectableRows && c.isRowSelected(n),
            i = c.isRowSelectable(n),
            l = f.setRowProps && f.setRowProps(o, n, t) || {},
            s = c.processRow(o, h);
        return React__default.createElement(React__default.Fragment, {
          key: t
        }, React__default.createElement(TableBodyRow$1, _extends({}, l, {
          options: f,
          rowSelected: r,
          isRowSelectable: i,
          onClick: c.handleRowClick.bind(null, o, {
            rowIndex: t,
            dataIndex: n
          }),
          className: clsx((_defineProperty(a = {}, d.lastStackedCell, "vertical" === f.responsive || "stacked" === f.responsive || "stackedFullWidth" === f.responsive), _defineProperty(a, d.lastSimpleCell, "simple" === f.responsive), _defineProperty(a, l.className, l.className), a)),
          "data-testid": "MUIDataTableBodyRow-" + n,
          id: "MUIDataTableBodyRow-" + n
        }), React__default.createElement(TableSelectCell$1, {
          onChange: c.handleRowSelect.bind(null, {
            index: c.getRowIndex(t),
            dataIndex: n
          }),
          onExpand: u.bind(null, {
            index: c.getRowIndex(t),
            dataIndex: n
          }),
          fixedHeader: f.fixedHeader,
          fixedSelectColumn: f.fixedSelectColumn,
          checked: r,
          expandableOn: f.expandableRows,
          hideExpandButton: !c.isRowExpandable(n) && f.expandableRows,
          selectableOn: f.selectableRows,
          selectableRowsHideCheckboxes: f.selectableRowsHideCheckboxes,
          isRowExpanded: c.isRowExpanded(n),
          isRowSelectable: i,
          dataIndex: n,
          id: "MUIDataTableSelectCell-" + n,
          components: m
        }), s.map(function (e) {
          return "true" === p[e.index].display && React__default.createElement(TableBodyCell, _extends({}, p[e.index].setCellProps && p[e.index].setCellProps(e.value, n, e.index) || {}, {
            "data-testid": "MuiDataTableBodyCell-".concat(e.index, "-").concat(t),
            dataIndex: n,
            rowIndex: t,
            colIndex: e.index,
            columnHeader: p[e.index].label,
            print: p[e.index].print,
            options: f,
            tableId: b,
            key: e.index
          }), e.value);
        })), c.isRowExpanded(n) && f.renderExpandableRow(o, {
          rowIndex: t,
          dataIndex: n
        }));
      }) : React__default.createElement(TableBodyRow$1, {
        options: f
      }, React__default.createElement(TableBodyCell, {
        colSpan: "none" !== f.selectableRows || f.expandableRows ? n + 1 : n,
        options: f,
        colIndex: 0,
        rowIndex: 0
      }, React__default.createElement(Typography, {
        variant: "body1",
        className: d.emptyTitle,
        component: "div"
      }, f.textLabels.body.noMatch))));
    }
  }]), n;
}();

_defineProperty(TableBody, "defaultProps", {
  toggleExpandRow: function toggleExpandRow() {}
});

var DefaultTableBody = styles.withStyles(defaultBodyStyles, {
  name: "MUIDataTableBody"
})(TableBody),
    defaultFilterStyles = function defaultFilterStyles(e) {
  return {
    root: {
      backgroundColor: e.palette.background.default,
      padding: "24px 24px 36px 24px",
      fontFamily: "Roboto"
    },
    header: {
      flex: "0 0 auto",
      marginBottom: "16px",
      width: "100%",
      display: "flex",
      justifyContent: "space-between"
    },
    title: {
      display: "inline-block",
      marginLeft: "7px",
      color: e.palette.text.primary,
      fontSize: "14px",
      fontWeight: 500
    },
    noMargin: {
      marginLeft: "0px"
    },
    reset: {
      alignSelf: "left"
    },
    resetLink: {
      marginLeft: "16px",
      fontSize: "12px",
      cursor: "pointer"
    },
    filtersSelected: {
      alignSelf: "right"
    },
    checkboxListTitle: {
      marginLeft: "7px",
      marginBottom: "8px",
      fontSize: "14px",
      color: e.palette.text.secondary,
      textAlign: "left",
      fontWeight: 500
    },
    checkboxFormGroup: {
      marginTop: "8px"
    },
    checkboxFormControl: {
      margin: "0px"
    },
    checkboxFormControlLabel: {
      fontSize: "15px",
      marginLeft: "8px",
      color: e.palette.text.primary
    },
    checkboxIcon: {
      width: "32px",
      height: "32px"
    },
    checkbox: {},
    checked: {},
    gridListTile: {
      marginTop: "16px"
    }
  };
},
    TableFilter = function () {
  _inherits(a, React__default.Component);

  var t = _createSuper(a);

  function a(e) {
    var i;
    return _classCallCheck(this, a), _defineProperty(_assertThisInitialized(i = t.call(this, e)), "filterUpdate", function (e, t, a, o, n) {
      var r = i.state.filterList.slice(0);
      i.props.updateFilterByType(r, e, t, o, n), i.setState({
        filterList: r
      });
    }), _defineProperty(_assertThisInitialized(i), "handleCheckboxChange", function (e, t, a) {
      i.filterUpdate(e, t, a, "checkbox"), !0 !== i.props.options.confirmFilters && i.props.onFilterUpdate(e, t, a, "checkbox");
    }), _defineProperty(_assertThisInitialized(i), "handleDropdownChange", function (e, t, a) {
      var o = i.props.options.textLabels.filter.all,
          n = e.target.value === o ? [] : [e.target.value];
      i.filterUpdate(t, n, a, "dropdown"), !0 !== i.props.options.confirmFilters && i.props.onFilterUpdate(t, n, a, "dropdown");
    }), _defineProperty(_assertThisInitialized(i), "handleMultiselectChange", function (e, t, a) {
      i.filterUpdate(e, t, a, "multiselect"), !0 !== i.props.options.confirmFilters && i.props.onFilterUpdate(e, t, a, "multiselect");
    }), _defineProperty(_assertThisInitialized(i), "handleTextFieldChange", function (e, t, a) {
      i.filterUpdate(t, e.target.value, a, "textField"), !0 !== i.props.options.confirmFilters && i.props.onFilterUpdate(t, e.target.value, a, "textField");
    }), _defineProperty(_assertThisInitialized(i), "handleCustomChange", function (e, t, a) {
      i.filterUpdate(t, e, a.name, a.filterType), !0 !== i.props.options.confirmFilters && i.props.onFilterUpdate(t, e, a.name, a.filterType);
    }), _defineProperty(_assertThisInitialized(i), "applyFilters", function () {
      return i.state.filterList.forEach(function (e, t) {
        i.props.onFilterUpdate(t, e, i.props.columns[t], "custom");
      }), i.props.handleClose(), i.props.options.onFilterConfirm && i.props.options.onFilterConfirm(i.state.filterList), i.state.filterList;
    }), _defineProperty(_assertThisInitialized(i), "resetFilters", function () {
      i.setState({
        filterList: i.props.columns.map(function () {
          return [];
        })
      }), !0 !== i.props.options.confirmFilters && i.props.onFilterReset();
    }), i.state = {
      filterList: cloneDeep(e.filterList)
    }, i;
  }

  return _createClass(a, [{
    key: "renderCheckbox",
    value: function value(a, o, e) {
      var n = this,
          r = (2 < arguments.length && void 0 !== e ? e : {}).Checkbox || Checkbox,
          t = this.props,
          i = t.classes,
          l = t.filterData,
          s = this.state.filterList,
          c = a.filterOptions && a.filterOptions.renderValue ? a.filterOptions.renderValue : function (e) {
        return e;
      };
      return React__default.createElement(core.GridListTile, {
        key: o,
        cols: 2
      }, React__default.createElement(FormGroup, null, React__default.createElement(core.Grid, {
        item: !0,
        xs: 12
      }, React__default.createElement(Typography, {
        variant: "body2",
        className: i.checkboxListTitle
      }, a.label)), React__default.createElement(core.Grid, {
        container: !0
      }, l[o].map(function (e, t) {
        return React__default.createElement(core.Grid, {
          item: !0,
          key: t
        }, React__default.createElement(FormControlLabel, {
          key: t,
          classes: {
            root: i.checkboxFormControl,
            label: i.checkboxFormControlLabel
          },
          control: React__default.createElement(r, {
            "data-description": "table-filter",
            color: "primary",
            className: i.checkboxIcon,
            onChange: n.handleCheckboxChange.bind(null, o, e, a.name),
            checked: 0 <= s[o].indexOf(e),
            classes: {
              root: i.checkbox,
              checked: i.checked
            },
            value: null != e ? e.toString() : ""
          }),
          label: c(e)
        }));
      }))));
    }
  }, {
    key: "renderSelect",
    value: function value(t, a) {
      var o = this,
          e = this.props,
          n = e.classes,
          r = e.filterData,
          i = e.options,
          l = this.state.filterList,
          s = i.textLabels.filter,
          c = t.filterOptions && t.filterOptions.renderValue ? t.filterOptions.renderValue : function (e) {
        return null != e ? e.toString() : "";
      },
          d = !0 === (t.filterOptions && t.filterOptions.fullWidth) ? 2 : 1;
      return React__default.createElement(core.GridListTile, {
        key: a,
        cols: d,
        classes: {
          tile: n.gridListTile
        }
      }, React__default.createElement(FormControl, {
        key: a,
        fullWidth: !0
      }, React__default.createElement(InputLabel, {
        htmlFor: t.name
      }, t.label), React__default.createElement(Select, {
        fullWidth: !0,
        value: l[a].length ? l[a].toString() : s.all,
        name: t.name,
        onChange: function onChange(e) {
          return o.handleDropdownChange(e, a, t.name);
        },
        input: React__default.createElement(Input, {
          name: t.name,
          id: t.name
        })
      }, React__default.createElement(MenuItem, {
        value: s.all,
        key: 0
      }, s.all), r[a].map(function (e, t) {
        return React__default.createElement(MenuItem, {
          value: e,
          key: t + 1
        }, c(e));
      }))));
    }
  }, {
    key: "renderTextField",
    value: function value(t, a) {
      var o = this,
          e = this.props.classes,
          n = this.state.filterList;
      t.filterOptions && t.filterOptions.renderValue && console.warn("Custom renderValue not supported for textField filters");
      var r = !0 === (t.filterOptions && t.filterOptions.fullWidth) ? 2 : 1;
      return React__default.createElement(core.GridListTile, {
        key: a,
        cols: r,
        classes: {
          tile: e.gridListTile
        }
      }, React__default.createElement(FormControl, {
        key: a,
        fullWidth: !0
      }, React__default.createElement(core.TextField, {
        fullWidth: !0,
        label: t.label,
        value: n[a].toString() || "",
        "data-testid": "filtertextfield-" + t.name,
        onChange: function onChange(e) {
          return o.handleTextFieldChange(e, a, t.name);
        }
      })));
    }
  }, {
    key: "renderMultiselect",
    value: function value(t, a, e) {
      var o = this,
          n = (2 < arguments.length && void 0 !== e ? e : {}).Checkbox || Checkbox,
          r = this.props,
          i = r.classes,
          l = r.filterData,
          s = this.state.filterList,
          c = t.filterOptions && t.filterOptions.renderValue ? t.filterOptions.renderValue : function (e) {
        return e;
      },
          d = !0 === (t.filterOptions && t.filterOptions.fullWidth) ? 2 : 1;
      return React__default.createElement(core.GridListTile, {
        key: a,
        cols: d,
        classes: {
          tile: i.gridListTile
        }
      }, React__default.createElement(FormControl, {
        key: a,
        fullWidth: !0
      }, React__default.createElement(InputLabel, {
        htmlFor: t.name
      }, t.label), React__default.createElement(Select, {
        multiple: !0,
        fullWidth: !0,
        value: s[a] || [],
        renderValue: function renderValue(e) {
          return e.map(c).join(", ");
        },
        name: t.name,
        onChange: function onChange(e) {
          return o.handleMultiselectChange(a, e.target.value, t.name);
        },
        input: React__default.createElement(Input, {
          name: t.name,
          id: t.name
        })
      }, l[a].map(function (e, t) {
        return React__default.createElement(MenuItem, {
          value: e,
          key: t + 1
        }, React__default.createElement(n, {
          "data-description": "table-filter",
          color: "primary",
          checked: 0 <= s[a].indexOf(e),
          value: null != e ? e.toString() : "",
          className: i.checkboxIcon,
          classes: {
            root: i.checkbox,
            checked: i.checked
          }
        }), React__default.createElement(ListItemText, {
          primary: c(e)
        }));
      }))));
    }
  }, {
    key: "renderCustomField",
    value: function value(e, t) {
      var a = this.props,
          o = a.classes,
          n = a.filterData,
          r = a.options,
          i = this.state.filterList,
          l = !0 === (e.filterOptions && e.filterOptions.fullWidth) ? 2 : 1,
          s = e.filterOptions && e.filterOptions.display || r.filterOptions && r.filterOptions.display;
      if (s) return e.filterListOptions && e.filterListOptions.renderValue && console.warning('"renderValue" is ignored for custom filter fields'), React__default.createElement(core.GridListTile, {
        key: t,
        cols: l,
        classes: {
          tile: o.gridListTile
        }
      }, React__default.createElement(FormControl, {
        key: t,
        fullWidth: !0
      }, s(i, this.handleCustomChange, t, e, n)));
      console.error('Property "display" is required when using custom filter type.');
    }
  }, {
    key: "render",
    value: function value() {
      var o = this,
          e = this.props,
          t = e.classes,
          a = e.columns,
          n = e.options,
          r = (e.onFilterReset, e.customFooter),
          i = e.filterList,
          l = e.components,
          s = void 0 === l ? {} : l,
          c = n.textLabels.filter,
          d = 1 === a.filter(function (e) {
        return e.filter;
      }).length ? 1 : 2;
      return React__default.createElement("div", {
        className: t.root
      }, React__default.createElement("div", {
        className: t.header
      }, React__default.createElement("div", {
        className: t.reset
      }, React__default.createElement(Typography, {
        variant: "body2",
        className: clsx(_defineProperty({}, t.title, !0))
      }, c.title), React__default.createElement(Button, {
        color: "primary",
        className: t.resetLink,
        tabIndex: 0,
        "aria-label": c.reset,
        "data-testid": "filterReset-button",
        onClick: this.resetFilters
      }, c.reset)), React__default.createElement("div", {
        className: t.filtersSelected
      })), React__default.createElement(core.GridList, {
        cellHeight: "auto",
        cols: d,
        spacing: 34
      }, a.map(function (e, t) {
        if (e.filter) {
          var a = e.filterType || n.filterType;
          return "checkbox" === a ? o.renderCheckbox(e, t, s) : "multiselect" === a ? o.renderMultiselect(e, t, s) : "textField" === a ? o.renderTextField(e, t) : "custom" === a ? o.renderCustomField(e, t) : o.renderSelect(e, t);
        }
      })), r ? r(i, this.applyFilters) : "");
    }
  }]), a;
}(),
    DefaultTableFilter = styles.withStyles(defaultFilterStyles, {
  name: "MUIDataTableFilter"
})(TableFilter),
    TableFilterListItem = function TableFilterListItem(e) {
  var t = e.label,
      a = e.onDelete,
      o = e.className,
      n = e.filterProps;
  return (n = n || {}).className && (o = clsx(o, n.className)), React__default.createElement(Chip, _extends({
    label: t,
    onDelete: a,
    className: o
  }, n));
},
    useStyles$1 = styles.makeStyles(function () {
  return {
    root: {
      display: "flex",
      justifyContent: "left",
      flexWrap: "wrap",
      margin: "0px 16px 0px 16px"
    },
    chip: {
      margin: "8px 8px 0px 0px"
    }
  };
}, {
  name: "MUIDataTableFilterList"
}),
    TableFilterList = function TableFilterList(e) {
  function i(t, e, a, o, n) {
    var r = 4 < arguments.length && void 0 !== n ? n : null,
        i = e;
    Array.isArray(i) && 0 === i.length && (i = s[t]), c(t, e, a, o, r, function (e) {
      l.onFilterChipClose && l.onFilterChipClose(t, i, e);
    });
  }

  function o(e, t, a, o, n) {
    var r = n ? u[t] ? "custom" : "chip" : p[t].filterType;
    return React__default.createElement(f, {
      label: e,
      key: a,
      onDelete: function onDelete() {
        return i(t, o[a] || [], p[t].name, r, u[t]);
      },
      className: h.chip,
      itemKey: a,
      index: t,
      data: o,
      columnNames: p,
      filterProps: l.setFilterChipProps ? l.setFilterChipProps(t, p[t].name, o[a] || []) : {}
    });
  }

  function t(t) {
    return t.map(function (a, r) {
      if ("custom" === p[r].filterType && t[r].length) {
        var e = d[r](a);
        return Array.isArray(e) ? e.map(function (e, t) {
          return o(e, r, t, a, !0);
        }) : o(e, r, r, a, !1);
      }

      return a.map(function (e, t) {
        return a = r, o = e, n = t, React__default.createElement(f, {
          label: d[a](o),
          key: n,
          onDelete: function onDelete() {
            return i(a, o, p[a].name, "chip");
          },
          className: h.chip,
          itemKey: n,
          index: a,
          data: o,
          columnNames: p,
          filterProps: l.setFilterChipProps ? l.setFilterChipProps(a, p[a].name, o) : {}
        });
        var a, o, n;
      });
    });
  }

  var l = e.options,
      s = e.filterList,
      c = e.filterUpdate,
      d = e.filterListRenderers,
      p = e.columnNames,
      a = e.serverSideFilterList,
      u = e.customFilterListUpdate,
      n = e.ItemComponent,
      f = void 0 === n ? TableFilterListItem : n,
      h = useStyles$1(),
      r = l.serverSide;
  return React__default.createElement("div", {
    className: h.root
  }, t(r && a ? a : s));
},
    useStyles$2 = styles.makeStyles(function (e) {
  return {
    root: {
      color: e.palette.text.primary
    },
    caption: {
      flexShrink: 0
    },
    selectRoot: {
      marginRight: 32,
      marginLeft: 8
    },
    select: {
      paddingTop: 6,
      paddingBottom: 7,
      paddingLeft: 8,
      paddingRight: 24,
      textAlign: "right",
      textAlignLast: "right",
      fontSize: e.typography.pxToRem(14)
    },
    selectIcon: {},
    input: {
      color: "inhert",
      fontSize: "inhert",
      flexShrink: 0
    }
  };
}, {
  name: "MUIDataTableJumpToPage"
});

function JumpToPage(t) {
  for (var a = useStyles$2(), e = t.count, o = t.textLabels, n = t.rowsPerPage, r = t.page, i = (t.changePage, o.pagination.jumpToPage), l = [], s = Math.min(1e3, getPageValue(e, n, 1e6)), c = 0; c <= s; c++) {
    l.push(c);
  }

  var d = core.MenuItem;
  return React__default.createElement(core.Toolbar, {
    style: {
      display: "flex",
      minHeight: "52px",
      alignItems: "center"
    },
    className: a.root
  }, React__default.createElement(core.Typography, {
    color: "inherit",
    variant: "body2",
    className: a.caption
  }, i), React__default.createElement(core.Select, {
    classes: {
      select: a.select,
      icon: a.selectIcon
    },
    input: React__default.createElement(core.InputBase, {
      className: clsx(a.input, a.selectRoot)
    }),
    value: getPageValue(e, n, r),
    onChange: function onChange(e) {
      t.changePage(parseInt(e.target.value, 10));
    },
    style: {
      marginRight: 0
    }
  }, l.map(function (e) {
    return React__default.createElement(d, {
      className: a.menuItem,
      key: e,
      value: e
    }, e + 1);
  })));
}

var useStyles$3 = styles.makeStyles(function (e) {
  return {
    root: {},
    tableCellContainer: {
      padding: "0px 24px 0px 24px"
    },
    navContainer: {
      display: "flex",
      justifyContent: "flex-end"
    },
    toolbar: {},
    selectRoot: {},
    "@media screen and (max-width: 400px)": {
      toolbar: {
        "& span:nth-child(2)": {
          display: "none"
        }
      },
      selectRoot: {
        marginRight: "8px"
      }
    }
  };
}, {
  name: "MUIDataTablePagination"
});

function TablePagination(a) {
  var e = useStyles$3(),
      t = a.count,
      o = a.options,
      n = a.rowsPerPage,
      r = a.page,
      i = o.textLabels.pagination;
  return React__default.createElement(MuiTableFooter, null, React__default.createElement(TableRow, null, React__default.createElement(TableCell, {
    colSpan: "1000",
    className: e.tableCellContainer
  }, React__default.createElement("div", {
    className: e.navContainer
  }, o.jumpToPage ? React__default.createElement(JumpToPage, {
    count: t,
    page: r,
    rowsPerPage: n,
    textLabels: o.textLabels,
    changePage: a.changePage,
    changeRowsPerPage: a.changeRowsPerPage
  }) : null, React__default.createElement(MuiTablePagination, {
    component: "div",
    className: e.root,
    classes: {
      caption: e.caption,
      toolbar: e.toolbar,
      selectRoot: e.selectRoot
    },
    count: t,
    rowsPerPage: n,
    page: getPageValue(t, n, r),
    labelRowsPerPage: i.rowsPerPage,
    labelDisplayedRows: function labelDisplayedRows(e) {
      var t = e.from,
          a = e.to,
          o = e.count;
      return "".concat(t, "-").concat(a, " ").concat(i.displayRows, " ").concat(o);
    },
    backIconButtonProps: {
      id: "pagination-back",
      "data-testid": "pagination-back",
      "aria-label": i.previous,
      title: i.previous || ""
    },
    nextIconButtonProps: {
      id: "pagination-next",
      "data-testid": "pagination-next",
      "aria-label": i.next,
      title: i.next || ""
    },
    SelectProps: {
      id: "pagination-input",
      SelectDisplayProps: {
        id: "pagination-rows",
        "data-testid": "pagination-rows"
      },
      MenuProps: {
        id: "pagination-menu",
        "data-testid": "pagination-menu",
        MenuListProps: {
          id: "pagination-menu-list",
          "data-testid": "pagination-menu-list"
        }
      }
    },
    rowsPerPageOptions: o.rowsPerPageOptions,
    onChangePage: function onChangePage(e, t) {
      a.changePage(t);
    },
    onChangeRowsPerPage: function onChangeRowsPerPage(e) {
      a.changeRowsPerPage(e.target.value);
    }
  })))));
}

var useStyles$4 = styles.makeStyles(function () {
  return {
    root: {
      "@media print": {
        display: "none"
      }
    }
  };
}, {
  name: "MUIDataTableFooter"
}),
    TableFooter = function TableFooter(e) {
  var t = e.options,
      a = e.rowCount,
      o = e.page,
      n = e.rowsPerPage,
      r = e.changeRowsPerPage,
      i = e.changePage,
      l = useStyles$4(),
      s = t.customFooter,
      c = t.pagination,
      d = void 0 === c || c;
  return s ? React__default.createElement(MuiTable, {
    className: l.root
  }, t.customFooter(a, o, n, r, i, t.textLabels.pagination)) : d ? React__default.createElement(MuiTable, {
    className: l.root
  }, React__default.createElement(TablePagination, {
    count: a,
    page: o,
    rowsPerPage: n,
    changeRowsPerPage: r,
    changePage: i,
    component: "div",
    options: t
  })) : null;
},
    getColModel = function getColModel(r, e, i) {
  var l = [],
      s = r[0] ? r[0] : null;
  null === s && (s = {
    offsetLeft: 1 / 0
  }, Object.entries(r).forEach(function (e, t) {
    var a = _slicedToArray(e, 2),
        o = (a[0], a[1]);

    o && o.offsetLeft < s.offsetLeft && (s = o);
  }), s.offsetLeft === 1 / 0 && (s = {
    offsetParent: 0,
    offsetWidth: 0,
    offsetLeft: 0
  }));

  for (var t = 0, c = 0, a = s.offsetParent; a && (c = c + (a.offsetLeft || 0) - (a.scrollLeft || 0), a = a.offsetParent, !(1e3 < ++t));) {
    ;
  }

  return r[0] && (l[0] = {
    left: c + s.offsetLeft,
    width: s.offsetWidth,
    columnIndex: null,
    ref: s
  }), e.forEach(function (e, t) {
    var a,
        o = r[e + 1],
        n = l.length - 1;
    i[e] && "true" !== i[e].display || (a = -1 != n ? l[n].left + l[n].width : c + s.offsetLeft, l.push({
      left: a,
      width: o.offsetWidth,
      columnIndex: e,
      ref: o
    }));
  }), l;
},
    reorderColumns = function reorderColumns(e, t, a) {
  var o,
      n = e.slice(),
      r = n.indexOf(t),
      i = n.indexOf(a);
  return -1 !== r && -1 !== i && (o = n[r], n = [].concat(_toConsumableArray(n.slice(0, r)), _toConsumableArray(n.slice(r + 1))), n = [].concat(_toConsumableArray(n.slice(0, i)), [o], _toConsumableArray(n.slice(i)))), n;
},
    handleHover = function handleHover(e) {
  e.item;
  var t = e.mon,
      a = e.index,
      o = e.headCellRefs,
      n = e.updateColumnOrder,
      r = e.columnOrder,
      i = e.transitionTime,
      l = void 0 === i ? 300 : i,
      s = e.tableRef,
      c = e.tableId,
      d = e.timers,
      p = e.columns,
      u = t.getItem().colIndex;

  if (o === t.getItem().headCellRefs && u !== a) {
    for (var f = reorderColumns(r, t.getItem().colIndex, a), h = getColModel(o, f, p), m = t.getClientOffset().x, b = -1, y = 0; y < h.length; y++) {
      if (m > h[y].left && m < h[y].left + h[y].width) {
        b = h[y].columnIndex;
        break;
      }
    }

    if (b === t.getItem().colIndex) {
      clearTimeout(d.columnShift);

      var _ = getColModel(o, r, p),
          g = [];

      h.forEach(function (e) {
        g[e.columnIndex] = e.left;
      }), _.forEach(function (e) {
        g[e.columnIndex] = g[e.columnIndex] - e.left;
      });

      for (var x = 1; x < r.length; x++) {
        var v = r[x];
        p[v] && "true" !== p[v].display || (o[x] && (o[x].style.transition = "280ms"), o[x] && (o[x].style.transform = "translateX(" + g[x - 1] + "px)"));
      }

      for (var R = [], w = [], T = 0; T < r.length; T++) {
        for (var C = s ? s.querySelectorAll('[data-colindex="' + T + '"][data-tableid="' + c + '"]') : [], S = 0; S < C.length; S++) {
          C[S].style.transition = l + "ms", C[S].style.transform = "translateX(" + g[T] + "px)", R.push(C[S]);
        }

        for (var P = s ? s.querySelectorAll('[data-divider-index="' + (T + 1) + '"][data-tableid="' + c + '"]') : [], I = 0; I < P.length; I++) {
          P[I].style.transition = l + "ms", P[I].style.transform = "translateX(" + g[r[T]] + "px)", w.push(P[I]);
        }
      }

      var k = t.getItem().colIndex;
      d.columnShift = setTimeout(function () {
        R.forEach(function (e) {
          e.style.transition = "0s", e.style.transform = "translateX(0)";
        }), w.forEach(function (e) {
          e.style.transition = "0s", e.style.transform = "translateX(0)";
        }), n(f, k, a);
      }, l);
    }
  }
},
    useColumnDrop = function useColumnDrop(a) {
  var e = _slicedToArray(reactDnd.useDrop({
    accept: "HEADER",
    drop: o,
    hover: function hover(e, t) {
      return handleHover(Object.assign({}, a, {
        item: e,
        mon: t
      }));
    },
    collect: function collect(e) {
      return {
        isOver: !!e.isOver(),
        canDrop: !!e.canDrop()
      };
    }
  }), 2),
      t = e[0],
      o = (t.isOver, t.canDrop, e[1]);

  return [o];
},
    useStyles$5 = styles.makeStyles(function (e) {
  return {
    root: {},
    fixedHeader: {
      position: "sticky",
      top: "0px",
      zIndex: 100,
      backgroundColor: e.palette.background.paper
    },
    tooltip: {
      cursor: "pointer"
    },
    mypopper: {
      "&[data-x-out-of-boundaries]": {
        display: "none"
      }
    },
    data: {
      display: "inline-block"
    },
    sortAction: {
      display: "flex",
      verticalAlign: "top",
      cursor: "pointer"
    },
    dragCursor: {
      cursor: "grab"
    },
    sortLabelRoot: {
      height: "10px"
    },
    sortActive: {
      color: e.palette.text.primary
    },
    toolButton: {
      display: "flex",
      outline: "none",
      cursor: "pointer"
    },
    hintIconAlone: {
      marginTop: "-3px",
      marginLeft: "3px"
    },
    hintIconWithSortIcon: {
      marginTop: "-3px"
    }
  };
}, {
  name: "MUIDataTableHeadCell"
}),
    TableHeadCell = function TableHeadCell(e) {
  function t() {
    return !!m && _.draggableColumns && _.draggableColumns.enabled && !1 !== s.draggable;
  }

  var a,
      o,
      n = e.cellHeaderProps,
      r = void 0 === n ? {} : n,
      i = e.children,
      l = e.colPosition,
      s = e.column,
      c = e.columns,
      d = e.columnOrder,
      p = void 0 === d ? [] : d,
      u = e.components,
      f = void 0 === u ? {} : u,
      h = e.draggableHeadCellRefs,
      m = e.draggingHook,
      b = e.hint,
      y = e.index,
      _ = e.options,
      g = e.print,
      x = e.setCellRef,
      v = e.sort,
      R = e.sortDirection,
      w = e.tableRef,
      T = e.tableId,
      C = e.timers,
      S = e.toggleSort,
      P = e.updateColumnOrder,
      I = _slicedToArray(React.useState(!1), 2),
      k = I[0],
      D = I[1],
      E = _slicedToArray(React.useState(!1), 2),
      O = E[0],
      A = E[1],
      L = useStyles$5(),
      F = _slicedToArray(m || [], 2),
      H = F[0],
      z = F[1],
      N = r.className,
      B = _objectWithoutProperties(r, ["className"]),
      M = f.Tooltip || MuiTooltip,
      W = "none" !== R && void 0 !== R,
      j = "none" !== R && R,
      U = _objectSpread2({
    classes: {
      root: L.sortLabelRoot
    },
    active: W,
    hideSortIcon: !0
  }, j ? {
    direction: R
  } : {}),
      q = _slicedToArray(reactDnd.useDrag({
    item: {
      type: "HEADER",
      colIndex: y,
      headCellRefs: h
    },
    begin: function begin() {
      return setTimeout(function () {
        A(!1), D(!1), z(!0);
      }, 0), null;
    },
    end: function end() {
      z(!1);
    },
    collect: function collect(e) {
      return {
        opacity: e.isDragging() ? 1 : 0
      };
    }
  }), 3),
      V = (q[0].opacity, q[1]),
      $ = (q[2], _slicedToArray(useColumnDrop({
    drop: function drop() {
      D(!1), A(!1), z(!1);
    },
    index: y,
    headCellRefs: h,
    updateColumnOrder: P,
    columnOrder: p,
    columns: c,
    transitionTime: _.draggableColumns ? _.draggableColumns.transitionTime : 300,
    tableRef: w ? w() : null,
    tableId: T || "none",
    timers: C
  }), 1)[0]),
      G = clsx((_defineProperty(a = {}, L.root, !0), _defineProperty(a, L.fixedHeader, _.fixedHeader), _defineProperty(a, "datatables-noprint", !g), _defineProperty(a, N, N), a));

  return React__default.createElement(TableCell, _extends({
    ref: function ref(e) {
      $ && $(e), x && x(y + 1, l + 1, e);
    },
    className: G,
    scope: "col",
    sortDirection: j,
    "data-colindex": y,
    "data-tableid": T,
    onMouseDown: function onMouseDown() {
      D(!1), z(!0);
    }
  }, B), _.sort && v ? React__default.createElement("span", {
    role: "button",
    onKeyUp: function onKeyUp(e) {
      return "Enter" === e.key && S(y), !1;
    },
    onClick: function onClick() {
      S(y);
    },
    className: L.toolButton,
    "data-testid": "headcol-".concat(y),
    ref: t() ? V : null,
    tabIndex: 0
  }, React__default.createElement(M, {
    title: !H && _.textLabels ? _.textLabels.body.columnHeaderTooltip ? _.textLabels.body.columnHeaderTooltip(s) : _.textLabels.body.toolTip : "",
    placement: "bottom-start",
    open: k,
    onOpen: function onOpen() {
      return D(!H);
    },
    onClose: function onClose() {
      return D(!1);
    },
    classes: {
      tooltip: L.tooltip,
      popper: L.mypopper
    }
  }, React__default.createElement("div", {
    className: L.sortAction
  }, React__default.createElement("div", {
    className: clsx((_defineProperty(o = {}, L.data, !0), _defineProperty(o, L.sortActive, W), _defineProperty(o, L.dragCursor, t()), o))
  }, i), React__default.createElement("div", {
    className: L.sortAction
  }, React__default.createElement(TableSortLabel, U)))), b && React__default.createElement(M, {
    title: b
  }, React__default.createElement(HelpIcon, {
    className: W ? L.hintIconWithSortIcon : L.hintIconAlone,
    fontSize: "small"
  }))) : React__default.createElement("div", {
    className: b ? L.sortAction : null,
    ref: t() ? V : null
  }, i, b && React__default.createElement(M, {
    title: b,
    placement: "bottom-end",
    open: O,
    onOpen: function onOpen() {
      return D(!1), void A(!0);
    },
    onClose: function onClose() {
      return A(!1);
    },
    classes: {
      tooltip: L.tooltip,
      popper: L.mypopper
    },
    enterDelay: 300
  }, React__default.createElement(HelpIcon, {
    className: L.hintIconAlone,
    fontSize: "small"
  }))));
},
    useStyles$6 = styles.makeStyles(function () {
  return {
    root: {}
  };
}, {
  name: "MUIDataTableHeadRow"
}),
    TableHeadRow = function TableHeadRow(e) {
  var t = e.children,
      a = useStyles$6();
  return React__default.createElement(TableRow, {
    className: clsx(_defineProperty({}, a.root, !0))
  }, t);
},
    useStyles$7 = styles.makeStyles(function (e) {
  return {
    main: {},
    responsiveStacked: _defineProperty({}, e.breakpoints.down("sm"), {
      display: "none"
    }),
    responsiveStackedAlways: {
      display: "none"
    },
    responsiveSimple: _defineProperty({}, e.breakpoints.down("xs"), {
      display: "none"
    })
  };
}, {
  name: "MUIDataTableHead"
}),
    TableHead = function TableHead(e) {
  var t,
      a = e.columnOrder,
      n = void 0 === a ? null : a,
      r = e.columns,
      o = e.components,
      i = void 0 === o ? {} : o,
      l = e.count,
      s = e.data,
      c = e.draggableHeadCellRefs,
      d = e.expandedRows,
      p = e.options,
      u = e.selectedRows,
      f = e.selectRowUpdate,
      h = e.setCellRef,
      m = e.sortOrder,
      b = void 0 === m ? {} : m,
      y = e.tableRef,
      _ = e.tableId,
      g = e.timers,
      x = e.toggleAllExpandableRows,
      v = e.toggleSort,
      R = e.updateColumnOrder,
      w = useStyles$7();
  null === n && (n = r ? r.map(function (e, t) {
    return t;
  }) : []);

  function T(e) {
    v(e);
  }

  var C = _slicedToArray(React.useState(!1), 2),
      S = C[0],
      P = C[1],
      I = u && u.data.length || 0,
      k = 0 < I && I < l,
      D = 0 < I && l <= I;

  if (!0 === p.disableToolbarSelect || "none" === p.selectToolbarPlacement || "above" === p.selectToolbarPlacement) if (D) {
    for (var E = 0; E < s.length; E++) {
      if (!u.lookup[s[E].dataIndex]) {
        k = !(D = !1);
        break;
      }
    }
  } else l < I && (k = !0);
  var O = n.map(function (e, t) {
    return {
      column: r[e],
      index: e,
      colPos: t
    };
  });
  return React__default.createElement(MuiTableHead, {
    className: clsx((_defineProperty(t = {}, w.responsiveStacked, "vertical" === p.responsive || "stacked" === p.responsive || "stackedFullWidth" === p.responsive), _defineProperty(t, w.responsiveStackedAlways, "verticalAlways" === p.responsive), _defineProperty(t, w.responsiveSimple, "simple" === p.responsive), _defineProperty(t, w.main, !0), t))
  }, React__default.createElement(TableHeadRow, null, React__default.createElement(TableSelectCell$1, {
    setHeadCellRef: h,
    onChange: function () {
      f("head", null);
    }.bind(null),
    indeterminate: k,
    checked: D,
    isHeaderCell: !0,
    expandedRows: d,
    expandableRowsHeader: p.expandableRowsHeader,
    expandableOn: p.expandableRows,
    selectableOn: p.selectableRows,
    fixedHeader: p.fixedHeader,
    fixedSelectColumn: p.fixedSelectColumn,
    selectableRowsHeader: p.selectableRowsHeader,
    onExpand: x,
    isRowSelectable: !0,
    components: i
  }), O.map(function (e) {
    var t = e.column,
        a = e.index,
        o = e.colPos;
    return "true" === t.display && (t.customHeadRender ? t.customHeadRender(_objectSpread2({
      index: a
    }, t), T, b) : React__default.createElement(TableHeadCell, {
      cellHeaderProps: r[a].setCellHeaderProps && r[a].setCellHeaderProps(_objectSpread2({
        index: a
      }, t)) || {},
      key: a,
      index: a,
      colPosition: o,
      type: "cell",
      setCellRef: h,
      sort: t.sort,
      sortDirection: t.name === b.name ? b.direction : "none",
      toggleSort: T,
      hint: t.hint,
      print: t.print,
      options: p,
      column: t,
      columns: r,
      updateColumnOrder: R,
      columnOrder: n,
      timers: g,
      draggingHook: [S, P],
      draggableHeadCellRefs: c,
      tableRef: y,
      tableId: _,
      components: i
    }, t.customHeadLabelRender ? t.customHeadLabelRender(_objectSpread2({
      index: a,
      colPos: o
    }, t)) : t.label));
  })));
},
    defaultResizeStyles = {
  root: {
    position: "absolute"
  },
  resizer: {
    position: "absolute",
    width: "1px",
    height: "100%",
    left: "100px",
    cursor: "ew-resize",
    border: "0.1px solid rgba(224, 224, 224, 1)"
  }
};

function getParentOffsetLeft(e) {
  for (var t = 0, a = 0, o = e.offsetParent; o && (a = a + (o.offsetLeft || 0) - (o.scrollLeft || 0), o = o.offsetParent, !(1e3 < ++t));) {
    ;
  }

  return a;
}

var TableResize = function () {
  _inherits(n, React__default.Component);

  var o = _createSuper(n);

  function n() {
    var S;

    _classCallCheck(this, n);

    for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
      t[a] = arguments[a];
    }

    return _defineProperty(_assertThisInitialized(S = o.call.apply(o, [this].concat(t))), "state", {
      resizeCoords: {},
      priorPosition: {},
      tableWidth: "100%",
      tableHeight: "100%"
    }), _defineProperty(_assertThisInitialized(S), "handleResize", function () {
      window.innerWidth !== S.windowWidth && (S.windowWidth = window.innerWidth, S.setDividers());
    }), _defineProperty(_assertThisInitialized(S), "setCellRefs", function (e, t) {
      S.cellsRef = e, S.tableRef = t, S.setDividers();
    }), _defineProperty(_assertThisInitialized(S), "setDividers", function () {
      var e = S.tableRef,
          t = e.getBoundingClientRect(),
          a = t.width,
          o = t.height,
          i = S.state.resizeCoords;

      for (var n in i) {
        delete i[n];
      }

      var l = getParentOffsetLeft(e);
      Object.entries(S.cellsRef).forEach(function (e, t) {
        var a,
            o = _slicedToArray(e, 2),
            n = o[0],
            r = o[1];

        r && (a = ((a = r.getBoundingClientRect().left) || 0) - l, window.getComputedStyle(r, null), i[n] = {
          left: a + r.offsetWidth
        });
      }), S.setState({
        tableWidth: a,
        tableHeight: o,
        resizeCoords: i
      }, S.updateWidths);
    }), _defineProperty(_assertThisInitialized(S), "updateWidths", function () {
      var i = 0,
          e = S.state,
          t = e.resizeCoords,
          l = e.tableWidth;
      Object.entries(t).forEach(function (e) {
        var t = _slicedToArray(e, 2),
            a = t[0],
            o = t[1],
            n = Number((o.left - i) / l * 100);

        "object" === _typeof(S.props.resizableColumns) && S.props.resizableColumns.roundWidthPercentages && (n = n.toFixed(2)), i = o.left;
        var r = S.cellsRef[a];
        r && (r.style.width = n + "%");
      });
    }), _defineProperty(_assertThisInitialized(S), "onResizeStart", function (e, t) {
      var a = S.tableRef,
          o = a.style.width,
          i = 0;
      a.style.width = "1px", Object.entries(S.cellsRef).forEach(function (e, t) {
        var a = _slicedToArray(e, 2),
            o = a[0],
            n = a[1],
            r = n ? n.getBoundingClientRect() : {
          width: 0,
          left: 0
        };

        S.minWidths[o] = r.width, i = Math.max(o, i);
      }), a.style.width = o, S.setState({
        isResize: !0,
        id: e,
        lastColumn: i
      });
    }), _defineProperty(_assertThisInitialized(S), "onResizeMove", function (e, t) {
      function n(e) {
        for (var t = e + 1, a = 0; void 0 === m[t] && a < 20;) {
          t++, a++;
        }

        return m[t];
      }

      function r(e) {
        for (var t = e - 1; void 0 === m[t] && 0 <= t;) {
          t--;
        }

        return m[t];
      }

      var a,
          o,
          i,
          l,
          s,
          c,
          d,
          p,
          u,
          f = S.state,
          h = f.isResize,
          m = f.resizeCoords,
          b = f.lastColumn,
          y = S.minWidths[e],
          _ = S.minWidths[function (e) {
        for (var t = e + 1, a = 0; void 0 === m[t] && a < 20;) {
          t++, a++;
        }

        return t;
      }(parseInt(e, 10))] || S.minWidths[e],
          g = parseInt(e, 10),
          x = (Object.entries(S.cellsRef), S.tableRef),
          v = x.getBoundingClientRect(),
          R = v.width,
          w = v.height,
          T = S.props.options.selectableRows,
          C = getParentOffsetLeft(x);

      h && (a = t.clientX - C, o = function o(e, t, a) {
        return t - a < e ? t - a : e;
      }, i = function i(e, t) {
        return e < t ? t : e;
      }, l = function l(e, t, a, o) {
        return void 0 !== n(a) && e > n(a).left - o ? n(a).left - o : e;
      }, s = function s(e, t, a, o) {
        return void 0 !== r(a) && e < r(a).left + o ? r(a).left + o : e;
      }, d = function d(e) {
        return e === function (e) {
          for (var t = e - 1; void 0 === m[t] && 0 <= t;) {
            t--;
          }

          return t;
        }(b);
      }, (c = function c(e, t) {
        for (var a = 1; !m[a] && a < 20;) {
          a++;
        }

        return "none" !== e && 0 === t || "none" === e && t === a;
      })(T, g) && d(g) ? a = o(a = i(a, y), R, _) : !c(T, g) && d(g) ? a = s(a = o(a, R, _), 0, g, y) : c(T, g) && !d(g) ? a = l(a = i(a, y), 0, g, _) : c(T, g) || d(g) || (a = l(a = s(a, 0, g, y), 0, g, _)), p = _objectSpread2(_objectSpread2({}, m[e]), {}, {
        left: a
      }), u = _objectSpread2(_objectSpread2({}, m), {}, _defineProperty({}, e, p)), S.setState({
        resizeCoords: u,
        tableHeight: w
      }, S.updateWidths));
    }), _defineProperty(_assertThisInitialized(S), "onResizeEnd", function (e, t) {
      S.setState({
        isResize: !1,
        id: null
      });
    }), S;
  }

  return _createClass(n, [{
    key: "componentDidMount",
    value: function value() {
      var e = this;
      this.minWidths = [], this.windowWidth = null, this.props.setResizeable(this.setCellRefs), this.props.updateDividers(function () {
        return e.setState({
          updateCoords: !0
        }, function () {
          return e.updateWidths;
        });
      }), window.addEventListener("resize", this.handleResize, !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      window.removeEventListener("resize", this.handleResize, !1);
    }
  }, {
    key: "render",
    value: function value() {
      var n = this,
          e = this.props,
          r = e.classes,
          i = e.tableId,
          t = this.state,
          l = t.id,
          s = t.isResize,
          a = t.resizeCoords,
          c = t.tableWidth,
          d = t.tableHeight;
      return React__default.createElement("div", {
        className: r.root,
        style: {
          width: c
        }
      }, Object.entries(a).map(function (e) {
        var t = _slicedToArray(e, 2),
            a = t[0],
            o = t[1];

        return React__default.createElement("div", {
          "data-divider-index": a,
          "data-tableid": i,
          "aria-hidden": "true",
          key: a,
          onMouseMove: n.onResizeMove.bind(null, a),
          onMouseUp: n.onResizeEnd.bind(null, a),
          style: {
            width: s && l == a ? c : "auto",
            position: "absolute",
            height: d - 2,
            cursor: "ew-resize",
            zIndex: 1e3
          }
        }, React__default.createElement("div", {
          "aria-hidden": "true",
          onMouseDown: n.onResizeStart.bind(null, a),
          className: r.resizer,
          style: {
            left: o.left
          }
        }));
      }));
    }
  }]), n;
}(),
    DefaultTableResize = styles.withStyles(defaultResizeStyles, {
  name: "MUIDataTableResize"
})(TableResize),
    Popover = function Popover(e) {
  e.className;

  var a = e.trigger,
      t = e.refExit,
      o = e.hide,
      n = e.content,
      r = _objectWithoutProperties(e, ["className", "trigger", "refExit", "hide", "content"]),
      i = _slicedToArray(React.useState(!1), 2),
      l = i[0],
      s = i[1],
      c = React.useRef(null);

  React.useEffect(function () {
    l && "boolean" == typeof o && o && s(!1);
  }, [o, l, s]);

  function d() {
    s(!1);
  }

  var p = r.classes.closeIcon;
  delete r.classes.closeIcon;
  var u = {
    key: "content",
    onClick: function onClick(e) {
      var t;
      a.props.onClick && a.props.onClick(), t = e, c.current = t.currentTarget, s(!0);
    }
  };
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("span", u, a), React__default.createElement(MuiPopover, _extends({
    elevation: 2,
    open: l,
    onClose: d,
    onExited: function onExited() {
      t && t();
    },
    anchorEl: c.current,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    }
  }, r), React__default.createElement(IconButton, {
    "aria-label": "Close",
    onClick: d,
    className: p,
    style: {
      position: "absolute",
      right: "4px",
      top: "4px",
      zIndex: "1000"
    }
  }, React__default.createElement(CloseIcon, null)), n));
},
    useStyles$8 = styles.makeStyles(function (e) {
  return {
    root: {
      padding: "16px 24px 16px 24px",
      fontFamily: "Roboto"
    },
    title: {
      marginLeft: "-7px",
      marginRight: "24px",
      fontSize: "14px",
      color: e.palette.text.secondary,
      textAlign: "left",
      fontWeight: 500
    },
    formGroup: {
      marginTop: "8px"
    },
    formControl: {},
    checkbox: {
      padding: "0px",
      width: "32px",
      height: "32px"
    },
    checkboxRoot: {},
    checked: {},
    label: {
      fontSize: "15px",
      marginLeft: "8px",
      color: e.palette.text.primary
    }
  };
}, {
  name: "MUIDataTableViewCol"
}),
    TableViewCol = function TableViewCol(e) {
  var t = e.columns,
      a = e.options,
      o = e.components,
      n = void 0 === o ? {} : o,
      r = e.onColumnUpdate,
      i = (e.updateColumns, useStyles$8()),
      l = a.textLabels.viewColumns,
      s = n.Checkbox || Checkbox;
  return React__default.createElement(FormControl, {
    component: "fieldset",
    className: i.root,
    "aria-label": l.titleAria
  }, React__default.createElement(Typography, {
    variant: "caption",
    className: i.title
  }, l.title), React__default.createElement(FormGroup, {
    className: i.formGroup
  }, t.map(function (e, t) {
    return "excluded" !== e.display && !1 !== e.viewColumns && React__default.createElement(FormControlLabel, {
      key: t,
      classes: {
        root: i.formControl,
        label: i.label
      },
      control: React__default.createElement(s, {
        color: "primary",
        "data-description": "table-view-col",
        className: i.checkbox,
        classes: {
          root: i.checkboxRoot,
          checked: i.checked
        },
        onChange: function onChange() {
          r(t);
        },
        checked: "true" === e.display,
        value: e.name
      }),
      label: e.label
    });
  })));
},
    useStyles$9 = styles.makeStyles(function (e) {
  return {
    main: {
      display: "flex",
      flex: "1 0 auto"
    },
    searchIcon: {
      color: e.palette.text.secondary,
      marginTop: "10px",
      marginRight: "8px"
    },
    searchText: {
      flex: "0.8 0"
    },
    clearIcon: {
      "&:hover": {
        color: e.palette.error.main
      }
    }
  };
}, {
  name: "MUIDataTableSearch"
}),
    TableSearch = function TableSearch(e) {
  var t = e.options,
      a = e.searchText,
      o = e.onSearch,
      n = e.onHide,
      r = useStyles$9();
  return React__default.createElement(Grow, {
    appear: !0,
    in: !0,
    timeout: 300
  }, React__default.createElement("div", {
    className: r.main
  }, React__default.createElement(SearchIcon, {
    className: r.searchIcon
  }), React__default.createElement(TextField, _extends({
    className: r.searchText,
    autoFocus: !0,
    InputProps: {
      "data-test-id": t.textLabels.toolbar.search
    },
    inputProps: {
      "aria-label": t.textLabels.toolbar.search
    },
    value: a || "",
    onKeyDown: function onKeyDown(e) {
      "Escape" === e.key && n();
    },
    onChange: function onChange(e) {
      o(e.target.value);
    },
    fullWidth: !0,
    placeholder: t.searchPlaceholder
  }, t.searchProps ? t.searchProps : {})), React__default.createElement(IconButton, {
    className: r.clearIcon,
    onClick: n
  }, React__default.createElement(ClearIcon, null))));
},
    defaultToolbarStyles = function defaultToolbarStyles(e) {
  var t = {
    root: {
      "@media print": {
        display: "none"
      }
    },
    fullWidthRoot: {},
    left: {
      flex: "1 1 auto"
    },
    fullWidthLeft: {
      flex: "1 1 auto"
    },
    actions: {
      flex: "1 1 auto",
      textAlign: "right"
    },
    fullWidthActions: {
      flex: "1 1 auto",
      textAlign: "right"
    },
    titleRoot: {},
    titleText: {},
    fullWidthTitleText: {
      textAlign: "left"
    },
    icon: {
      "&:hover": {
        color: e.palette.primary.main
      }
    },
    iconActive: {
      color: e.palette.primary.main
    },
    filterPaper: {
      maxWidth: "50%"
    },
    filterCloseIcon: {
      position: "absolute",
      right: 0,
      top: 0,
      zIndex: 100
    },
    searchIcon: {
      display: "inline-flex",
      marginTop: "10px",
      marginRight: "8px"
    }
  };
  return _defineProperty(t, e.breakpoints.down("sm"), {
    titleRoot: {},
    titleText: {
      fontSize: "16px"
    },
    spacer: {
      display: "none"
    },
    left: {
      padding: "8px 0px"
    },
    actions: {
      textAlign: "right"
    }
  }), _defineProperty(t, e.breakpoints.down("xs"), {
    root: {
      display: "block",
      "@media print": {
        display: "none !important"
      }
    },
    left: {
      padding: "8px 0px 0px 0px"
    },
    titleText: {
      textAlign: "center"
    },
    actions: {
      textAlign: "center"
    }
  }), _defineProperty(t, "@media screen and (max-width: 480px)", {}), t;
},
    RESPONSIVE_FULL_WIDTH_NAME = "scrollFullHeightFullWidth",
    TableToolbar = function () {
  _inherits(n, React__default.Component);

  var o = _createSuper(n);

  function n() {
    var d;

    _classCallCheck(this, n);

    for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
      t[a] = arguments[a];
    }

    return _defineProperty(_assertThisInitialized(d = o.call.apply(o, [this].concat(t))), "state", {
      iconActive: null,
      showSearch: Boolean(d.props.searchText || d.props.options.searchText || d.props.options.searchOpen),
      searchText: d.props.searchText || null
    }), _defineProperty(_assertThisInitialized(d), "handleCSVDownload", function () {
      var e,
          t = d.props,
          n = t.data,
          a = t.displayData,
          o = t.columns,
          r = t.options,
          i = t.columnOrder,
          l = [],
          s = [],
          c = Array.isArray(i) ? i.slice(0) : [];
      0 === c.length && (c = o.map(function (e, t) {
        return t;
      })), n.forEach(function (t) {
        var a = {
          index: t.index,
          data: []
        };
        c.forEach(function (e) {
          a.data.push(t.data[e]);
        }), l.push(a);
      }), c.forEach(function (e) {
        s.push(o[e]);
      }), r.downloadOptions && r.downloadOptions.filterOptions && (r.downloadOptions.filterOptions.useDisplayedRowsOnly && (e = a.map(function (a, e) {
        var o = -1;
        return a.index = e, {
          data: a.data.map(function (e) {
            o += 1;
            var t = "object" !== _typeof(e) || null === e || Array.isArray(e) ? e : find(n, function (e) {
              return e.index === a.dataIndex;
            }).data[o];
            return t = "function" == typeof t ? find(n, function (e) {
              return e.index === a.dataIndex;
            }).data[o] : t;
          })
        };
      }), l = [], e.forEach(function (t) {
        var a = {
          index: t.index,
          data: []
        };
        c.forEach(function (e) {
          a.data.push(t.data[e]);
        }), l.push(a);
      })), r.downloadOptions.filterOptions.useDisplayedColumnsOnly && (s = s.filter(function (e) {
        return "true" === e.display;
      }), l = l.map(function (e) {
        return e.data = e.data.filter(function (e, t) {
          return "true" === o[c[t]].display;
        }), e;
      }))), createCSVDownload(s, l, r, downloadCSV);
    }), _defineProperty(_assertThisInitialized(d), "setActiveIcon", function (t) {
      d.setState(function (e) {
        return {
          showSearch: d.isSearchShown(t),
          iconActive: t,
          prevIconActive: e.iconActive
        };
      }, function () {
        var e = d.state,
            t = e.iconActive,
            a = e.prevIconActive;
        "filter" === t && (d.props.setTableAction("onFilterDialogOpen"), d.props.options.onFilterDialogOpen && d.props.options.onFilterDialogOpen()), void 0 === t && "filter" === a && (d.props.setTableAction("onFilterDialogClose"), d.props.options.onFilterDialogClose && d.props.options.onFilterDialogClose());
      });
    }), _defineProperty(_assertThisInitialized(d), "isSearchShown", function (e) {
      var t,
          a = !1;
      return d.state.showSearch ? a = !!d.state.searchText || (t = d.props.options.onSearchClose, d.props.setTableAction("onSearchClose"), t && t(), !1) : "search" === e && (a = d.showSearch()), a;
    }), _defineProperty(_assertThisInitialized(d), "getActiveIcon", function (e, t) {
      var a,
          o,
          n,
          r = d.state.iconActive === t;
      return "search" === t && (o = (a = d.state).showSearch, n = a.searchText, r = r || o || n), r ? e.iconActive : e.icon;
    }), _defineProperty(_assertThisInitialized(d), "showSearch", function () {
      return d.props.setTableAction("onSearchOpen"), d.props.options.onSearchOpen && d.props.options.onSearchOpen(), !0;
    }), _defineProperty(_assertThisInitialized(d), "hideSearch", function () {
      var e = d.props.options.onSearchClose;
      d.props.setTableAction("onSearchClose"), e && e(), d.props.searchClose(), d.setState(function () {
        return {
          iconActive: null,
          showSearch: !1,
          searchText: null
        };
      });
    }), _defineProperty(_assertThisInitialized(d), "handleSearch", function (e) {
      d.setState({
        searchText: e
      }), d.props.searchTextUpdate(e);
    }), _defineProperty(_assertThisInitialized(d), "handleSearchIconClick", function () {
      var e = d.state,
          t = e.showSearch,
          a = e.searchText;
      t && !a ? d.hideSearch() : d.setActiveIcon("search");
    }), d;
  }

  return _createClass(n, [{
    key: "componentDidUpdate",
    value: function value(e) {
      this.props.searchText !== e.searchText && this.setState({
        searchText: this.props.searchText
      });
    }
  }, {
    key: "render",
    value: function value() {
      var t = this,
          e = this.props,
          a = e.data,
          o = e.options,
          n = e.classes,
          r = e.columns,
          i = e.filterData,
          l = e.filterList,
          s = e.filterUpdate,
          c = e.resetFilters,
          d = e.toggleViewColumn,
          p = e.updateColumns,
          u = e.title,
          f = e.components,
          h = void 0 === f ? {} : f,
          m = e.updateFilterByType,
          b = h.Tooltip || MuiTooltip,
          y = h.TableViewCol || TableViewCol,
          _ = h.TableFilter || DefaultTableFilter,
          g = o.textLabels.toolbar,
          x = g.search,
          v = g.downloadCsv,
          R = g.print,
          w = g.viewColumns,
          T = g.filterTable,
          C = this.state,
          S = C.showSearch,
          P = C.searchText;

      return React__default.createElement(Toolbar, {
        className: o.responsive !== RESPONSIVE_FULL_WIDTH_NAME ? n.root : n.fullWidthRoot,
        role: "toolbar",
        "aria-label": "Table Toolbar"
      }, React__default.createElement("div", {
        className: o.responsive !== RESPONSIVE_FULL_WIDTH_NAME ? n.left : n.fullWidthLeft
      }, !0 === S ? o.customSearchRender ? o.customSearchRender(P, this.handleSearch, this.hideSearch, o) : React__default.createElement(TableSearch, {
        searchText: P,
        onSearch: this.handleSearch,
        onHide: this.hideSearch,
        options: o
      }) : "string" != typeof u ? u : React__default.createElement("div", {
        className: n.titleRoot,
        "aria-hidden": "true"
      }, React__default.createElement(Typography, {
        variant: "h6",
        className: o.responsive !== RESPONSIVE_FULL_WIDTH_NAME ? n.titleText : n.fullWidthTitleText
      }, u))), React__default.createElement("div", {
        className: o.responsive !== RESPONSIVE_FULL_WIDTH_NAME ? n.actions : n.fullWidthActions
      }, o.search && React__default.createElement(b, {
        title: x,
        disableFocusListener: !0
      }, React__default.createElement(IconButton, {
        "aria-label": x,
        "data-testid": x + "-iconButton",
        buttonRef: function buttonRef(e) {
          return t.searchButton = e;
        },
        classes: {
          root: this.getActiveIcon(n, "search")
        },
        onClick: this.handleSearchIconClick
      }, React__default.createElement(SearchIcon, null))), o.download && React__default.createElement(b, {
        title: v
      }, React__default.createElement(IconButton, {
        "data-testid": v + "-iconButton",
        "aria-label": v,
        classes: {
          root: n.icon
        },
        onClick: this.handleCSVDownload
      }, React__default.createElement(DownloadIcon, null))), o.print && React__default.createElement("span", null, React__default.createElement(ReactToPrint, {
        trigger: function trigger() {
          return React__default.createElement("span", null, React__default.createElement(b, {
            title: R
          }, React__default.createElement(IconButton, {
            "data-testid": R + "-iconButton",
            "aria-label": R,
            classes: {
              root: n.icon
            }
          }, React__default.createElement(PrintIcon, null))));
        },
        content: function content() {
          return t.props.tableRef();
        }
      })), o.viewColumns && React__default.createElement(Popover, {
        refExit: this.setActiveIcon.bind(null),
        classes: {
          closeIcon: n.filterCloseIcon
        },
        trigger: React__default.createElement(b, {
          title: w,
          disableFocusListener: !0
        }, React__default.createElement(IconButton, {
          "data-testid": w + "-iconButton",
          "aria-label": w,
          classes: {
            root: this.getActiveIcon(n, "viewcolumns")
          },
          onClick: this.setActiveIcon.bind(null, "viewcolumns")
        }, React__default.createElement(ViewColumnIcon, null))),
        content: React__default.createElement(y, {
          data: a,
          columns: r,
          options: o,
          onColumnUpdate: d,
          updateColumns: p,
          components: h
        })
      }), o.filter && React__default.createElement(Popover, {
        refExit: function refExit() {
          t.setState({
            hideFilterPopover: !1
          }), t.setActiveIcon.bind(null);
        },
        hide: this.state.hideFilterPopover,
        classes: {
          paper: n.filterPaper,
          closeIcon: n.filterCloseIcon
        },
        trigger: React__default.createElement(b, {
          title: T,
          disableFocusListener: !0
        }, React__default.createElement(IconButton, {
          "data-testid": T + "-iconButton",
          "aria-label": T,
          classes: {
            root: this.getActiveIcon(n, "filter")
          },
          onClick: this.setActiveIcon.bind(null, "filter")
        }, React__default.createElement(FilterIcon, null))),
        content: React__default.createElement(_, {
          customFooter: o.customFilterDialogFooter,
          columns: r,
          options: o,
          filterList: l,
          filterData: i,
          onFilterUpdate: s,
          onFilterReset: c,
          handleClose: function handleClose() {
            t.setState({
              hideFilterPopover: !0
            });
          },
          updateFilterByType: m,
          components: h
        })
      }), o.customToolbar && o.customToolbar()));
    }
  }]), n;
}(),
    DefaultTableToolbar = styles.withStyles(defaultToolbarStyles, {
  name: "MUIDataTableToolbar"
})(TableToolbar),
    defaultToolbarSelectStyles = function defaultToolbarSelectStyles(e) {
  return {
    root: {
      backgroundColor: e.palette.background.default,
      flex: "1 1 100%",
      display: "flex",
      position: "relative",
      zIndex: 120,
      justifyContent: "space-between",
      alignItems: "center",
      paddingTop: "function" == typeof e.spacing ? e.spacing(1) : e.spacing.unit,
      paddingBottom: "function" == typeof e.spacing ? e.spacing(1) : e.spacing.unit,
      "@media print": {
        display: "none"
      }
    },
    title: {
      paddingLeft: "26px"
    },
    iconButton: {
      marginRight: "24px"
    },
    deleteIcon: {}
  };
},
    TableToolbarSelect = function () {
  _inherits(r, React__default.Component);

  var n = _createSuper(r);

  function r() {
    var a;

    _classCallCheck(this, r);

    for (var e = arguments.length, t = new Array(e), o = 0; o < e; o++) {
      t[o] = arguments[o];
    }

    return _defineProperty(_assertThisInitialized(a = n.call.apply(n, [this].concat(t))), "handleCustomSelectedRows", function (e) {
      if (!Array.isArray(e)) throw new TypeError('"selectedRows" must be an "array", but it\'s "'.concat(_typeof(e), '"'));
      if (e.some(function (e) {
        return "number" != typeof e;
      })) throw new TypeError('Array "selectedRows" must contain only numbers');
      var t = a.props.options;
      if (1 < e.length && "single" === t.selectableRows) throw new Error('Can not select more than one row when "selectableRows" is "single"');
      a.props.selectRowUpdate("custom", e);
    }), a;
  }

  return _createClass(r, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.classes,
          a = e.onRowsDelete,
          o = e.selectedRows,
          n = e.options,
          r = e.displayData,
          i = e.components,
          l = void 0 === i ? {} : i,
          s = n.textLabels.selectedRows,
          c = l.Tooltip || MuiTooltip;
      return React__default.createElement(Paper, {
        className: t.root
      }, React__default.createElement("div", null, React__default.createElement(Typography, {
        variant: "subtitle1",
        className: t.title
      }, o.data.length, " ", s.text)), n.customToolbarSelect ? n.customToolbarSelect(o, r, this.handleCustomSelectedRows) : React__default.createElement(c, {
        title: s.delete
      }, React__default.createElement(IconButton, {
        className: t.iconButton,
        onClick: a,
        "aria-label": s.deleteAria
      }, React__default.createElement(DeleteIcon, {
        className: t.deleteIcon
      }))));
    }
  }]), r;
}(),
    DefaultTableToolbarSelect = styles.withStyles(defaultToolbarSelectStyles, {
  name: "MUIDataTableToolbarSelect"
})(TableToolbarSelect),
    getTextLabels = function getTextLabels() {
  return {
    body: {
      noMatch: "Sorry, no matching records found",
      toolTip: "Sort"
    },
    pagination: {
      next: "Next Page",
      previous: "Previous Page",
      rowsPerPage: "Rows per page:",
      displayRows: "of",
      jumpToPage: "Jump to Page:"
    },
    toolbar: {
      search: "Search",
      downloadCsv: "Download CSV",
      print: "Print",
      viewColumns: "View Columns",
      filterTable: "Filter Table"
    },
    filter: {
      all: "All",
      title: "FILTERS",
      reset: "RESET"
    },
    viewColumns: {
      title: "Show Columns",
      titleAria: "Show/Hide Table Columns"
    },
    selectedRows: {
      text: "row(s) selected",
      delete: "Delete",
      deleteAria: "Delete Selected Rows"
    }
  };
},
    defaultTableStyles = function defaultTableStyles(e) {
  return {
    root: {},
    paper: {},
    paperResponsiveScrollFullHeightFullWidth: {
      position: "absolute"
    },
    tableRoot: {
      outline: "none"
    },
    responsiveBase: {
      overflow: "auto",
      "@media print": {
        height: "auto !important"
      }
    },
    responsiveScroll: {
      overflow: "auto",
      height: "100%"
    },
    responsiveScrollMaxHeight: {
      overflow: "auto",
      height: "100%"
    },
    responsiveScrollFullHeight: {
      height: "100%"
    },
    responsiveStacked: _defineProperty({
      overflow: "auto"
    }, e.breakpoints.down("sm"), {
      overflow: "hidden"
    }),
    responsiveStackedFullWidth: {},
    caption: {
      position: "absolute",
      left: "-3000px"
    },
    liveAnnounce: {
      border: "0",
      clip: "rect(0 0 0 0)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: "0",
      position: "absolute",
      width: "1px"
    },
    "@global": {
      "@media print": {
        ".datatables-noprint": {
          display: "none"
        }
      }
    }
  };
},
    TABLE_LOAD = {
  INITIAL: 1,
  UPDATE: 2
},
    TOOLBAR_ITEMS = ["title", "filter", "search", "print", "download", "viewColumns", "customToolbar"],
    hasToolbarItem = function hasToolbarItem(t, e) {
  return t.title = e, !isUndefined(find(TOOLBAR_ITEMS, function (e) {
    return t[e];
  }));
},
    STP = {
  REPLACE: "replace",
  ABOVE: "above",
  NONE: "none"
},
    MUIDataTable = function () {
  _inherits(a, React__default.Component);

  var t = _createSuper(a);

  function a(e) {
    var u;
    _classCallCheck(this, a), _defineProperty(_assertThisInitialized(u = t.call(this, e)), "getDefaultOptions", function () {
      return {
        caseSensitive: !1,
        consoleWarnings: !0,
        disableToolbarSelect: !1,
        download: !0,
        downloadOptions: {
          filename: "tableDownload.csv",
          separator: ","
        },
        draggableColumns: {
          enabled: !1,
          transitionTime: 300
        },
        elevation: 4,
        enableNestedDataAccess: "",
        expandableRows: !1,
        expandableRowsHeader: !0,
        expandableRowsOnClick: !1,
        filter: !0,
        filterArrayFullMatch: !0,
        filterType: "dropdown",
        fixedHeader: !0,
        fixedSelectColumn: !0,
        pagination: !0,
        print: !0,
        resizableColumns: !1,
        responsive: "vertical",
        rowHover: !0,
        rowsPerPageOptions: [10, 15, 100],
        search: !0,
        selectableRows: "multiple",
        selectableRowsHideCheckboxes: !1,
        selectableRowsOnClick: !1,
        selectableRowsHeader: !0,
        serverSide: !1,
        serverSideFilterList: null,
        setTableProps: function setTableProps() {
          return {};
        },
        sort: !0,
        sortFilterList: !0,
        tableBodyHeight: "auto",
        tableBodyMaxHeight: null,
        sortOrder: {},
        textLabels: getTextLabels(),
        viewColumns: !0,
        selectToolbarPlacement: STP.REPLACE
      };
    }), _defineProperty(_assertThisInitialized(u), "warnDep", function (e, t) {
      warnDeprecated(e, u.options.consoleWarnings);
    }), _defineProperty(_assertThisInitialized(u), "warnInfo", function (e, t) {
      warnInfo(e, u.options.consoleWarnings);
    }), _defineProperty(_assertThisInitialized(u), "handleOptionDeprecation", function (e) {
      "boolean" == typeof u.options.selectableRows && (u.warnDep("Using a boolean for selectableRows has been deprecated. Please use string option: multiple | single | none"), u.options.selectableRows = u.options.selectableRows ? "multiple" : "none"), -1 === ["standard", "vertical", "verticalAlways", "simple"].indexOf(u.options.responsive) && (-1 !== ["scrollMaxHeight", "scrollFullHeight", "stacked", "stackedFullWidth", "scrollFullHeightFullWidth", "scroll"].indexOf(u.options.responsive) ? u.warnDep(u.options.responsive + " has been deprecated, but will still work in version 3.x. Please use string option: standard | vertical | simple. More info: https://github.com/gregnb/mui-datatables/tree/master/docs/v2_to_v3_guide.md") : u.warnInfo(u.options.responsive + " is not recognized as a valid input for responsive option. Please use string option: standard | vertical | simple. More info: https://github.com/gregnb/mui-datatables/tree/master/docs/v2_to_v3_guide.md")), u.options.onRowsSelect && u.warnDep("onRowsSelect has been renamed onRowSelectionChange. More info: https://github.com/gregnb/mui-datatables/tree/master/docs/v2_to_v3_guide.md"), u.options.onRowsExpand && u.warnDep("onRowsExpand has been renamed onRowExpansionChange. More info: https://github.com/gregnb/mui-datatables/tree/master/docs/v2_to_v3_guide.md"), u.options.fixedHeaderOptions && (void 0 !== u.options.fixedHeaderOptions.yAxis && void 0 === u.options.fixedHeader && (u.options.fixedHeader = u.options.fixedHeaderOptions.yAxis), void 0 !== u.options.fixedHeaderOptions.xAxis && void 0 === u.options.fixedSelectColumn && (u.options.fixedSelectColumn = u.options.fixedHeaderOptions.xAxis), u.warnDep("fixedHeaderOptions will still work but has been deprecated in favor of fixedHeader and fixedSelectColumn. More info: https://github.com/gregnb/mui-datatables/tree/master/docs/v2_to_v3_guide.md")), u.options.serverSideFilterList && u.warnDep("serverSideFilterList will still work but has been deprecated in favor of the confirmFilters option. See this example for details: https://github.com/gregnb/mui-datatables/blob/master/examples/serverside-filters/index.js More info here: https://github.com/gregnb/mui-datatables/tree/master/docs/v2_to_v3_guide.md"), e.columns.map(function (e) {
        e.options && e.options.customFilterListRender && u.warnDep("The customFilterListRender option has been deprecated. It is being replaced by customFilterListOptions.render (Specify customFilterListOptions: { render: Function } in column options.)");
      }), !0 === u.options.disableToolbarSelect && u.warnDep('disableToolbarSelect has been deprecated but will still work in version 3.x. It is being replaced by "selectToolbarPlacement"="none". More info: https://github.com/gregnb/mui-datatables/tree/master/docs/v2_to_v3_guide.md'), Object.values && -1 === Object.values(STP).indexOf(u.options.selectToolbarPlacement) && u.warnDep("Invalid option value for selectToolbarPlacement. Please check the documentation: https://github.com/gregnb/mui-datatables#options");
    }), _defineProperty(_assertThisInitialized(u), "setTableAction", function (e) {
      "function" == typeof u.options.onTableChange && u.options.onTableChange(e, u.state);
    }), _defineProperty(_assertThisInitialized(u), "setTableInit", function (e) {
      "function" == typeof u.options.onTableInit && u.options.onTableInit(e, u.state);
    }), _defineProperty(_assertThisInitialized(u), "setHeadCellRef", function (e, t, a) {
      u.draggableHeadCellRefs[e] = a, u.resizeHeadCellRefs[t] = a;
    }), _defineProperty(_assertThisInitialized(u), "getTableContentRef", function () {
      return u.tableContent.current;
    }), _defineProperty(_assertThisInitialized(u), "buildColumns", function (e) {
      var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [],
          t = 2 < arguments.length ? arguments[2] : void 0,
          a = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : [],
          r = [],
          i = [],
          l = [],
          s = [];
      return e.forEach(function (e, t) {
        var a = {
          display: "true",
          empty: !1,
          filter: !0,
          sort: !0,
          print: !0,
          searchable: !0,
          download: !0,
          viewColumns: !0,
          sortCompare: null,
          sortThirdClickReset: !1,
          sortDescFirst: !1
        };
        s.push(t);

        var o = _objectSpread2({}, e.options),
            a = "object" === _typeof(e) ? (o && (void 0 !== o.display && (o.display = o.display.toString()), null !== o.sortDirection && !o.sortDirection || u.warnDep("The sortDirection column field has been deprecated. Please use the sortOrder option on the options object. More info: https://github.com/gregnb/mui-datatables/tree/master/docs/v2_to_v3_guide.md")), void 0 === o.display && n[t] && n[t].name === e.name && n[t].display && (o.display = n[t].display), _objectSpread2(_objectSpread2({
          name: e.name,
          label: e.label ? e.label : e.name
        }, a), o)) : (n[t] && n[t].display && (o.display = n[t].display), _objectSpread2(_objectSpread2(_objectSpread2({}, a), o), {}, {
          name: e,
          label: e
        }));

        r.push(a), i[t] = [], l[t] = [];
      }), Array.isArray(t) ? s = t : Array.isArray(a) && Array.isArray(e) && Array.isArray(n) && e.length === n.length && (s = a), {
        columns: r,
        filterData: i,
        filterList: l,
        columnOrder: s
      };
    }), _defineProperty(_assertThisInitialized(u), "transformData", function (e, t) {
      var n = u.options.enableNestedDataAccess;
      return Array.isArray(t[0]) ? t.map(function (t) {
        var a = -1;
        return e.map(function (e) {
          return e.empty || a++, e.empty ? void 0 : t[a];
        });
      }) : t.map(function (o) {
        return e.map(function (e) {
          return t = o, a = e.name, (n ? a.split(n) : a.split()).reduce(function (e, t) {
            return e ? e[t] : void 0;
          }, t);
          var t, a;
        });
      });
    }), _defineProperty(_assertThisInitialized(u), "hasSearchText", function (e, t, a) {
      var o = e.toString(),
          n = t.toString();
      return a || (n = n.toLowerCase(), o = o.toLowerCase()), 0 <= o.indexOf(n);
    }), _defineProperty(_assertThisInitialized(u), "updateDataCol", function (s, c, d) {
      u.setState(function (e) {
        var t,
            a = cloneDeep(e.data),
            o = cloneDeep(e.filterData),
            n = u.getTableMeta(s, c, s, e.columns[c], e.data, e, e.data),
            r = e.columns[c].customBodyRender(d, n),
            i = React__default.isValidElement(r) && r.props.value ? r.props.value : e.data[s][c],
            l = o[c].indexOf(i);
        return o[c].splice(l, 1, i), a[s].data[c] = d, u.options.sortFilterList && (t = getCollatorComparator(), o[c].sort(t)), {
          data: a,
          filterData: o,
          displayData: u.getDisplayData(e.columns, a, e.filterList, e.searchText, null, u.props)
        };
      });
    }), _defineProperty(_assertThisInitialized(u), "getTableMeta", function (e, t, a, o, n, r, i) {
      r.columns, r.data, r.displayData, r.filterData;
      return {
        rowIndex: e,
        columnIndex: t,
        columnData: o,
        rowData: a,
        tableData: n,
        tableState: _objectWithoutProperties(r, ["columns", "data", "displayData", "filterData"]),
        currentTableData: i
      };
    }), _defineProperty(_assertThisInitialized(u), "toggleViewColumn", function (a) {
      u.setState(function (e) {
        var t = cloneDeep(e.columns);
        return t[a].display = "true" === t[a].display ? "false" : "true", {
          columns: t
        };
      }, function () {
        u.setTableAction("viewColumnsChange");
        var e = u.options.onViewColumnsChange || u.options.onColumnViewChange;
        e && e(u.state.columns[a].name, "true" === u.state.columns[a].display ? "add" : "remove");
      });
    }), _defineProperty(_assertThisInitialized(u), "updateColumns", function (t) {
      u.setState(function (e) {
        return {
          columns: t
        };
      }, function () {
        u.setTableAction("viewColumnsChange");
        var e = u.options.onViewColumnsChange || u.options.onColumnViewChange;
        e && e(null, "update", t);
      });
    }), _defineProperty(_assertThisInitialized(u), "toggleSortColumn", function (d) {
      u.setState(function (e) {
        var t,
            a = cloneDeep(e.columns),
            o = e.data,
            n = a[d].sortDescFirst ? "desc" : "asc",
            r = ["asc", "desc"];
        a[d].sortDescFirst && (r = ["desc", "asc"]), a[d].sortThirdClickReset && r.push("none"), a[d].name !== u.state.sortOrder.name || -1 !== (t = r.indexOf(u.state.sortOrder.direction)) && (++t >= r.length && (t = 0), n = r[t]);
        var i,
            l = {
          name: a[d].name,
          direction: n
        },
            s = u.getSortDirectionLabel(l),
            c = {
          columns: a,
          announceText: "Table now sorted by ".concat(a[d].name, " : ").concat(s),
          activeColumn: d
        };
        return c = u.options.serverSide ? _objectSpread2(_objectSpread2({}, c), {}, {
          data: e.data,
          displayData: e.displayData,
          selectedRows: e.selectedRows,
          sortOrder: l
        }) : (i = u.sortTable(o, d, n, a[d].sortCompare), _objectSpread2(_objectSpread2({}, c), {}, {
          data: i.data,
          displayData: u.getDisplayData(a, i.data, e.filterList, e.searchText, null, u.props),
          selectedRows: i.selectedRows,
          sortOrder: l,
          previousSelectedRow: null
        }));
      }, function () {
        u.setTableAction("sort"), u.options.onColumnSortChange && u.options.onColumnSortChange(u.state.sortOrder.name, u.state.sortOrder.direction);
      });
    }), _defineProperty(_assertThisInitialized(u), "changeRowsPerPage", function (e) {
      var t = u.options.count || u.state.displayData.length;
      u.setState(function () {
        return {
          rowsPerPage: e,
          page: getPageValue(t, e, u.state.page)
        };
      }, function () {
        u.setTableAction("changeRowsPerPage"), u.options.onChangeRowsPerPage && u.options.onChangeRowsPerPage(u.state.rowsPerPage);
      });
    }), _defineProperty(_assertThisInitialized(u), "changePage", function (e) {
      u.setState(function () {
        return {
          page: e
        };
      }, function () {
        u.setTableAction("changePage"), u.options.onChangePage && u.options.onChangePage(u.state.page);
      });
    }), _defineProperty(_assertThisInitialized(u), "searchClose", function () {
      u.setState(function (e) {
        return {
          searchText: null,
          displayData: u.options.serverSide ? e.displayData : u.getDisplayData(e.columns, e.data, e.filterList, null, null, u.props)
        };
      }, function () {
        u.setTableAction("search"), u.options.onSearchChange && u.options.onSearchChange(u.state.searchText);
      });
    }), _defineProperty(_assertThisInitialized(u), "searchTextUpdate", function (t) {
      u.setState(function (e) {
        return {
          searchText: t && t.length ? t : null,
          page: 0,
          displayData: u.options.serverSide ? e.displayData : u.getDisplayData(e.columns, e.data, e.filterList, t, null, u.props)
        };
      }, function () {
        u.setTableAction("search"), u.options.onSearchChange && u.options.onSearchChange(u.state.searchText);
      });
    }), _defineProperty(_assertThisInitialized(u), "resetFilters", function () {
      u.setState(function (e) {
        var t = e.columns.map(function () {
          return [];
        });
        return {
          filterList: t,
          displayData: u.options.serverSide ? e.displayData : u.getDisplayData(e.columns, e.data, t, e.searchText, null, u.props)
        };
      }, function () {
        u.setTableAction("resetFilters"), u.options.onFilterChange && u.options.onFilterChange(null, u.state.filterList, "reset", null);
      });
    }), _defineProperty(_assertThisInitialized(u), "updateFilterByType", function (e, t, a, o, n) {
      var r = e[t].findIndex(function (e) {
        return isEqual(e, a);
      });

      switch (o) {
        case "checkbox":
        case "chip":
          0 <= r ? e[t].splice(r, 1) : e[t].push(a);
          break;

        case "multiselect":
          e[t] = "" === a ? [] : a;
          break;

        case "dropdown":
          e[t] = a;
          break;

        case "custom":
          n ? e = n(e, r, t) : e[t] = a;
          break;

        default:
          e[t] = 0 <= r || "" === a ? [] : [a];
      }
    }), _defineProperty(_assertThisInitialized(u), "filterUpdate", function (a, o, e, n, r, t) {
      u.setState(function (e) {
        var t = cloneDeep(e.filterList);
        return u.updateFilterByType(t, a, o, n, r), {
          page: 0,
          filterList: t,
          displayData: u.options.serverSide ? e.displayData : u.getDisplayData(e.columns, e.data, t, e.searchText, null, u.props),
          previousSelectedRow: null
        };
      }, function () {
        u.setTableAction("filterChange"), u.options.onFilterChange && u.options.onFilterChange(e, u.state.filterList, n, a, u.state.displayData), t && t(u.state.filterList);
      });
    }), _defineProperty(_assertThisInitialized(u), "toggleAllExpandableRows", function () {
      var e = _toConsumableArray(u.state.expandedRows.data),
          t = u.options.isRowExpandable,
          a = [];

      if (0 < e.length) for (var o = e.length - 1; 0 <= o; o--) {
        var n = e[o];
        (!t || t && t(n.dataIndex, u.state.expandedRows)) && a.push(e.splice(o, 1));
      } else for (var r = 0; r < u.state.data.length; r++) {
        var i,
            l = u.state.data[r];
        (!t || t && t(l.dataIndex, u.state.expandedRows)) && !0 !== u.state.expandedRows.lookup[l.index] && (i = {
          index: r,
          dataIndex: l.index
        }, e.push(i), a.push(i));
      }
      u.setState({
        expandedRows: {
          lookup: buildMap(e),
          data: e
        }
      }, function () {
        u.setTableAction("expandRow"), u.options.onRowExpansionChange && u.options.onRowExpansionChange(a, u.state.expandedRows.data, u.state.expandedRows.data.map(function (e) {
          return e.dataIndex;
        }));
      });
    }), _defineProperty(_assertThisInitialized(u), "areAllRowsExpanded", function () {
      return u.state.expandedRows.data.length === u.state.data.length;
    }), _defineProperty(_assertThisInitialized(u), "updateColumnOrder", function (t, e, a) {
      u.setState(function (e) {
        return {
          columnOrder: t
        };
      }, function () {
        u.setTableAction("columnOrderChange"), u.options.onColumnOrderChange && u.options.onColumnOrderChange(u.state.columnOrder, e, a);
      });
    }), _defineProperty(_assertThisInitialized(u), "selectRowDelete", function () {
      var e = u.state,
          t = e.selectedRows,
          a = e.data,
          o = e.filterList,
          n = buildMap(t.data),
          r = a.filter(function (e) {
        var t = e.index;
        return !n[t];
      });
      u.options.onRowsDelete && !1 === u.options.onRowsDelete(t, r.map(function (e) {
        return e.data;
      })) || u.setTableData({
        columns: u.props.columns,
        data: r,
        options: {
          filterList: o
        }
      }, TABLE_LOAD.UPDATE, !0, function () {
        u.setTableAction("rowDelete");
      });
    }), _defineProperty(_assertThisInitialized(u), "toggleExpandRow", function (e) {
      for (var t = e.dataIndex, a = u.options.isRowExpandable, o = u.state.expandedRows, n = _toConsumableArray(o.data), r = !1, i = !1, l = [], s = 0; s < n.length; s++) {
        if (n[s].dataIndex === t) {
          r = !0;
          break;
        }
      }

      r ? (a && a(t, o) || !a) && (l = n.splice(s, 1), i = !0) : (a && a(t, o) || !a) && n.push(e), u.setState({
        curExpandedRows: i ? l : [e],
        expandedRows: {
          lookup: buildMap(n),
          data: n
        }
      }, function () {
        u.setTableAction("rowExpansionChange"), (u.options.onRowExpansionChange || u.options.onRowsExpand) && (u.options.onRowExpansionChange || u.options.onRowsExpand)(u.state.curExpandedRows, u.state.expandedRows.data);
      });
    }), _defineProperty(_assertThisInitialized(u), "selectRowUpdate", function (e, s) {
      var c,
          t,
          a,
          o,
          d = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : [],
          p = u.options.selectableRows;
      "none" !== p && ("head" === e ? (c = u.options.isRowSelectable, u.setState(function (e) {
        var o = e.displayData,
            n = e.selectedRows,
            t = e.selectedRows.data.length,
            a = t === o.length || t < o.length && 0 < t,
            r = _toConsumableArray(o.reduce(function (e, t, a) {
          return (!c || c(o[a].dataIndex, n)) && e.push({
            index: a,
            dataIndex: o[a].dataIndex
          }), e;
        }, [])),
            i = buildMap(r);

        if (u.options.selectToolbarPlacement === STP.NONE) if (t > o.length) a = !0;else for (var l = 0; l < o.length; l++) {
          i[o[l].dataIndex] || (a = !0);
        }
        return a && (r = e.selectedRows.data.filter(function (e) {
          var t = e.dataIndex;
          return !i[t];
        }), i = buildMap(r)), {
          curSelectedRows: r,
          selectedRows: {
            data: r,
            lookup: i
          },
          previousSelectedRow: null
        };
      }, function () {
        u.setTableAction("rowSelectionChange"), u.options.onRowSelectionChange ? u.options.onRowSelectionChange(u.state.curSelectedRows, u.state.selectedRows.data, u.state.selectedRows.data.map(function (e) {
          return e.dataIndex;
        })) : u.options.onRowsSelect && u.options.onRowsSelect(u.state.curSelectedRows, u.state.selectedRows.data, u.state.selectedRows.data.map(function (e) {
          return e.dataIndex;
        }));
      })) : "cell" === e ? u.setState(function (e) {
        for (var t, a = s.dataIndex, o = _toConsumableArray(e.selectedRows.data), n = -1, r = 0; r < o.length; r++) {
          if (o[r].dataIndex === a) {
            n = r;
            break;
          }
        }

        if (0 <= n) {
          if (o.splice(n, 1), 0 < d.length) for (var i = buildMap(d), l = o.length - 1; 0 <= l; l--) {
            i[o[l].dataIndex] && o.splice(l, 1);
          }
        } else "single" === p ? o = [s] : (o.push(s), 0 < d.length && (t = buildMap(o), d.forEach(function (e) {
          t[e.dataIndex] || o.push(e);
        })));

        return {
          selectedRows: {
            lookup: buildMap(o),
            data: o
          },
          previousSelectedRow: s
        };
      }, function () {
        u.setTableAction("rowSelectionChange"), u.options.onRowSelectionChange ? u.options.onRowSelectionChange([s], u.state.selectedRows.data, u.state.selectedRows.data.map(function (e) {
          return e.dataIndex;
        })) : u.options.onRowsSelect && u.options.onRowsSelect([s], u.state.selectedRows.data, u.state.selectedRows.data.map(function (e) {
          return e.dataIndex;
        }));
      }) : "custom" === e && (t = u.state.displayData, o = buildMap(a = s.map(function (e) {
        return {
          index: e,
          dataIndex: t[e].dataIndex
        };
      })), u.setState({
        selectedRows: {
          data: a,
          lookup: o
        },
        previousSelectedRow: null
      }, function () {
        u.setTableAction("rowSelectionChange"), u.options.onRowSelectionChange ? u.options.onRowSelectionChange(u.state.selectedRows.data, u.state.selectedRows.data, u.state.selectedRows.data.map(function (e) {
          return e.dataIndex;
        })) : u.options.onRowsSelect && u.options.onRowsSelect(u.state.selectedRows.data, u.state.selectedRows.data, u.state.selectedRows.data.map(function (e) {
          return e.dataIndex;
        }));
      })));
    }), u.tableRef = React__default.createRef(), u.tableContent = React__default.createRef(), u.draggableHeadCellRefs = {}, u.resizeHeadCellRefs = {}, u.timers = {}, u.setHeadResizeable = function () {}, u.updateDividers = function () {};
    return u.mergeDefaultOptions(e), u.state = Object.assign({
      activeColumn: null,
      announceText: null,
      count: 0,
      columns: [],
      expandedRows: {
        data: [],
        lookup: {}
      },
      data: [],
      displayData: [],
      filterData: [],
      filterList: [],
      page: 0,
      previousSelectedRow: null,
      rowsPerPage: 10,
      searchProps: {},
      searchText: null,
      selectedRows: {
        data: [],
        lookup: {}
      },
      showResponsive: !1,
      sortOrder: {}
    }, u.getInitTableOptions()), u.setTableData = u.setTableData.bind(_assertThisInitialized(u)), u.setTableData(e, TABLE_LOAD.INITIAL, !0, null, !0), u;
  }

  return _createClass(a, [{
    key: "componentDidMount",
    value: function value() {
      this.setHeadResizeable(this.resizeHeadCellRefs, this.tableRef), this.props.options.searchText && !this.props.options.serverSide && this.setState({
        page: 0
      }), this.setTableInit("tableInitialized");
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      var t,
          a = this;
      this.props.data === e.data && this.props.columns === e.columns && this.props.options === e.options || (this.updateOptions(this.options, this.props), t = this.props.data !== e.data, this.props.data && e.data && (t = t && this.props.data.length === e.data.length), this.setTableData(this.props, TABLE_LOAD.INITIAL, t, function () {
        a.setTableAction("propsUpdate");
      })), this.props.options.searchText === e.options.searchText || this.props.options.serverSide || this.setState({
        page: 0
      }), (!0 === this.options.resizableColumns || this.options.resizableColumns && this.options.resizableColumns.enabled) && (this.setHeadResizeable(this.resizeHeadCellRefs, this.tableRef), this.updateDividers());
    }
  }, {
    key: "updateOptions",
    value: function value(e, t) {
      !0 === t.options.disableToolbarSelect && void 0 === t.options.selectToolbarPlacement && (t.options.selectToolbarPlacement = STP.NONE), t.options.draggableColumns && !0 === t.options.draggableColumns.enabled && !t.options.tableId && (t.options.tableId = (Math.random() + "").replace(/\./, "")), this.options = assignwith(e, t.options, function (e, t, a) {
        if ("textLabels" === a || "downloadOptions" === a) return merge(e, t);
      }), this.handleOptionDeprecation(t);
    }
  }, {
    key: "mergeDefaultOptions",
    value: function value(e) {
      var t = this.getDefaultOptions(),
          a = Object.assign({}, e);
      a.options = a.options || {}, this.updateOptions(t, a);
    }
  }, {
    key: "validateOptions",
    value: function value(e) {
      if (e.serverSide && void 0 === e.onTableChange) throw Error("onTableChange callback must be provided when using serverSide option");
      if (e.expandableRows && void 0 === e.renderExpandableRow) throw Error("renderExpandableRow must be provided when using expandableRows option");
      e.rowsSelected && Array.isArray(e.rowsSelected) && e.rowsSelected.some(isNaN) && warnInfo("When using the rowsSelected option, must be provided an array of numbers only.");
    }
  }, {
    key: "getInitTableOptions",
    value: function value() {
      var a = this,
          e = ["rowsPerPage", "page", "rowsSelected", "rowsPerPageOptions"].reduce(function (e, t) {
        return void 0 !== a.options[t] && (e[t] = a.options[t]), e;
      }, {});
      return this.validateOptions(e), e;
    }
  }, {
    key: "setTableData",
    value: function value(e, l, t, a, o) {
      var s,
          c,
          d = this,
          n = 3 < arguments.length && void 0 !== a ? a : function () {},
          r = 4 < arguments.length && void 0 !== o && o,
          p = [],
          i = this.buildColumns(e.columns, this.state.columns, this.options.columnOrder, this.state.columnOrder),
          u = i.columns,
          f = i.filterData,
          h = i.filterList,
          m = i.columnOrder,
          b = null,
          y = "none";
      this.options.sortOrder && this.options.sortOrder.direction && this.options.sortOrder.name ? c = Object.assign({}, this.options.sortOrder) : (c = Object.assign({}, this.state.sortOrder)).direction || e.columns.forEach(function (e, t) {
        !e.options || "asc" !== e.options.sortDirection && "desc" !== e.options.sortDirection || (c.name = e.name, c.sortDirection = e.sortDirection);
      });

      var _ = l === TABLE_LOAD.INITIAL ? this.transformData(u, e.data) : e.data,
          g = l === TABLE_LOAD.INITIAL ? this.options.searchText : null;

      void 0 === this.options.searchText && void 0 !== this.state.searchText && (g = this.state.searchText);
      var x = this.state.rowsPerPage;
      "number" == typeof this.options.rowsPerPage && (x = this.options.rowsPerPage);
      var v = this.state.page;
      "number" == typeof this.options.page && (v = this.options.page), u.forEach(function (e, a) {
        for (var t, o = 0; o < _.length; o++) {
          var n,
              r,
              i = l === TABLE_LOAD.INITIAL ? _[o][a] : _[o].data[a];
          void 0 === p[o] && p.push({
            index: l === TABLE_LOAD.INITIAL ? o : _[o].index,
            data: l === TABLE_LOAD.INITIAL ? _[o] : _[o].data
          }), !1 !== e.filter && ("function" == typeof e.customBodyRender && (n = p[o].data, s = d.getTableMeta(o, a, n, e, _, d.state, p), r = e.customBodyRender(i, s), React__default.isValidElement(r) && r.props.value ? i = r.props.value : "string" == typeof r && (i = r)), "object" !== _typeof(i) || Array.isArray(i) || null === i || (i = i.toString ? i.toString() : ""), f[a].indexOf(i) < 0 && !Array.isArray(i) ? f[a].push(i) : Array.isArray(i) && i.forEach(function (e) {
            var t = "object" === _typeof(e) && null !== e || "function" == typeof e ? e.toString ? e.toString() : "" : e;
            f[a].indexOf(t) < 0 && f[a].push(t);
          }));
        }

        e.filterOptions && (Array.isArray(e.filterOptions) ? (f[a] = cloneDeep(e.filterOptions), d.warnDep("filterOptions must now be an object. see https://github.com/gregnb/mui-datatables/tree/master/examples/customize-filter example")) : Array.isArray(e.filterOptions.names) && (f[a] = cloneDeep(e.filterOptions.names))), e.filterList ? h[a] = cloneDeep(e.filterList) : d.state.filterList && d.state.filterList[a] && 0 < d.state.filterList[a].length && (h[a] = cloneDeep(d.state.filterList[a])), d.options.sortFilterList && (t = getCollatorComparator(), f[a].sort(t)), e.name === c.name && (y = c.direction, b = a);
      });
      var R = {
        data: [],
        lookup: {}
      },
          w = {
        data: [],
        lookup: {}
      };
      if (this.options.rowsSelected && this.options.rowsSelected.length && "multiple" === this.options.selectableRows) this.options.rowsSelected.filter(function (e) {
        return 0 === e || Number(e) && 0 < e;
      }).forEach(function (e) {
        for (var t = e, a = 0; a < d.state.displayData.length; a++) {
          if (d.state.displayData[a].dataIndex === e) {
            t = a;
            break;
          }
        }

        R.data.push({
          index: t,
          dataIndex: e
        }), R.lookup[e] = !0;
      });else if (this.options.rowsSelected && 1 === this.options.rowsSelected.length && "single" === this.options.selectableRows) {
        for (var T = this.options.rowsSelected[0], C = 0; C < this.state.displayData.length; C++) {
          if (this.state.displayData[C].dataIndex === this.options.rowsSelected[0]) {
            T = C;
            break;
          }
        }

        R.data.push({
          index: T,
          dataIndex: this.options.rowsSelected[0]
        }), R.lookup[this.options.rowsSelected[0]] = !0;
      } else this.options.rowsSelected && 1 < this.options.rowsSelected.length && "single" === this.options.selectableRows ? console.error('Multiple values provided for selectableRows, but selectableRows set to "single". Either supply only a single value or use "multiple".') : void 0 === this.options.rowsSelected && !1 === t && this.state.selectedRows && (R = Object.assign({}, this.state.selectedRows));
      this.options.rowsExpanded && this.options.rowsExpanded.length && this.options.expandableRows ? this.options.rowsExpanded.forEach(function (e) {
        for (var t = e, a = 0; a < d.state.displayData.length; a++) {
          if (d.state.displayData[a].dataIndex === e) {
            t = a;
            break;
          }
        }

        w.data.push({
          index: t,
          dataIndex: e
        }), w.lookup[e] = !0;
      }) : void 0 === this.options.rowsExpanded && !1 === t && this.state.expandedRows && (w = Object.assign({}, this.state.expandedRows)), this.options.serverSide || null === b || (p = this.sortTable(p, b, y, u[b].sortCompare).data);
      var S = {
        columns: u,
        filterData: f,
        filterList: h,
        searchText: g,
        selectedRows: R,
        expandedRows: w,
        count: this.options.count,
        data: p,
        sortOrder: c,
        rowsPerPage: x,
        page: v,
        displayData: this.getDisplayData(u, p, h, g, s, e),
        columnOrder: m
      };
      r ? this.state = Object.assign({}, this.state, S) : this.setState(S, n);
    }
  }, {
    key: "computeDisplayRow",
    value: function value(d, p, u, f, h, m, b, e, y) {
      for (var _ = this, g = !1, x = !1, v = [], t = 0; t < p.length; t++) {
        !function (e) {
          var t,
              a,
              o = p[e],
              n = p[e],
              r = d[e];
          r.customBodyRenderLite ? v.push(r.customBodyRenderLite) : (r.customBodyRender && (t = _.getTableMeta(u, e, p, r, m, _objectSpread2(_objectSpread2({}, _.state), {}, {
            filterList: f,
            searchText: h
          }), y), a = r.customBodyRender(n, t, _.updateDataCol.bind(null, u, e)), n = "string" != typeof (o = a) && a ? a.props && a.props.value ? a.props.value : n : a), v.push(o));
          var i = null == n ? "" : n.toString(),
              l = f[e],
              s = b.caseSensitive,
              c = r.filterType || b.filterType;
          !l.length && "custom" !== c || (r.filterOptions && r.filterOptions.logic ? r.filterOptions.logic(n, l, p) && (g = !0) : "textField" === c && !_.hasSearchText(i, l, s) || "textField" !== c && !1 === Array.isArray(n) && l.indexOf(n) < 0 ? g = !0 : "textField" !== c && Array.isArray(n) && (b.filterArrayFullMatch ? l.every(function (e) {
            return 0 <= n.indexOf(e);
          }) || (g = !0) : l.some(function (e) {
            return 0 <= n.indexOf(e);
          }) || (g = !0))), h && "excluded" !== r.display && _.hasSearchText(i, h, s) && "false" !== r.display && r.searchable && (x = !0);
        }(t);
      }

      var a,
          o = e.options.customSearch;
      return h && o && ("boolean" != typeof (a = o(h, p, d)) ? console.error("customSearch must return a boolean") : x = a), b.serverSide ? (o && console.warn("Server-side filtering is enabled, hence custom search will be ignored."), v) : g || h && !x ? null : v;
    }
  }, {
    key: "getDisplayData",
    value: function value(e, t, a, o, n, r) {
      for (var i = [], l = n ? n.tableData : r.data, s = 0; s < t.length; s++) {
        var c = t[s].data,
            d = this.computeDisplayRow(e, c, s, a, o, l, this.options, r, t);
        d && i.push({
          data: d,
          dataIndex: t[s].index
        });
      }

      return i;
    }
  }, {
    key: "getSortDirectionLabel",
    value: function value(e) {
      switch (e.direction) {
        case "asc":
          return "ascending";

        case "desc":
          return "descending";

        case "none":
          return "none";

        default:
          return "";
      }
    }
  }, {
    key: "getTableProps",
    value: function value() {
      var e = this.props.classes,
          t = this.options.setTableProps() || {};
      return t.className = clsx(e.tableRoot, t.className), t;
    }
  }, {
    key: "sortTable",
    value: function value(e, a, t, o) {
      var n,
          r = this,
          i = 3 < arguments.length && void 0 !== o ? o : null,
          l = this.options.customSort && !i,
          s = {
        selectedRows: this.state.selectedRows
      },
          c = l ? this.options.customSort(e, a, t || (this.options.sortDescFirst ? "desc" : "asc"), s) : e;
      "none" === t && (n = e.reduce(function (e, t) {
        return e[t.index] = t, e;
      }, []));
      var d,
          p = c.map(function (e, t) {
        return {
          data: e.data[a],
          rowData: e.data,
          position: t,
          rowSelected: !!r.state.selectedRows.lookup[e.index]
        };
      });
      l || (d = i || sortCompare, p.sort(d(t)));

      for (var u = [], f = [], h = 0; h < p.length; h++) {
        var m = p[h];
        u.push(c[m.position]), m.rowSelected && f.push({
          index: h,
          dataIndex: c[m.position].index
        });
      }

      return {
        data: "none" === t ? n : u,
        selectedRows: {
          lookup: buildMap(f),
          data: f
        }
      };
    }
  }, {
    key: "render",
    value: function value() {
      var e,
          t = this,
          a = this.props,
          o = a.classes,
          n = a.className,
          r = a.title,
          i = a.components,
          l = i.TableBody,
          s = i.TableFilterList,
          c = i.TableFooter,
          d = i.TableHead,
          p = i.TableResize,
          u = i.TableToolbar,
          f = i.TableToolbarSelect,
          h = i.DragDropBackend,
          m = void 0 === h ? reactDndHtml5Backend.HTML5Backend : h,
          b = this.state,
          y = b.announceText,
          _ = b.activeColumn,
          g = b.data,
          x = b.displayData,
          v = b.columns,
          R = b.page,
          w = b.filterData,
          T = b.filterList,
          C = b.selectedRows,
          S = b.previousSelectedRow,
          P = b.expandedRows,
          I = b.searchText,
          k = b.sortOrder,
          D = (b.serverSideFilterList, b.columnOrder),
          E = l || DefaultTableBody,
          O = s || TableFilterList,
          A = c || TableFooter,
          L = d || TableHead,
          F = p || DefaultTableResize,
          H = u || DefaultTableToolbar,
          z = f || DefaultTableToolbarSelect,
          N = this.state.count || x.length,
          B = this.options.pagination ? this.state.rowsPerPage : x.length,
          M = hasToolbarItem(this.options, r),
          W = v.map(function (e) {
        return {
          name: e.name,
          filterType: e.filterType || t.options.filterType
        };
      }),
          j = this.options.responsive,
          U = "".concat(o.paper, " ").concat(n),
          q = this.options.tableBodyMaxHeight;

      switch (j) {
        case "scroll":
          e = o.responsiveScroll, q = "499px";
          break;

        case "scrollMaxHeight":
          e = o.responsiveScrollMaxHeight, q = "499px";
          break;

        case "scrollFullHeight":
          e = o.responsiveScrollFullHeight, q = "none";
          break;

        case "scrollFullHeightFullWidth":
          e = o.responsiveScrollFullHeight, U = "".concat(o.paperResponsiveScrollFullHeightFullWidth, " ").concat(n);
          break;

        case "stacked":
          e = o.responsiveStacked, q = "none";
          break;

        case "stackedFullWidth":
          e = o.responsiveStackedFullWidth, U = "".concat(o.paperResponsiveScrollFullHeightFullWidth, " ").concat(n), q = "none";
          break;

        default:
          e = o.responsiveBase;
      }

      var V = {};
      q && (V.maxHeight = q), this.options.tableBodyHeight && (V.height = this.options.tableBodyHeight);
      var $ = this.options.setTableProps && this.options.setTableProps() || {},
          G = clsx(o.tableRoot, $.className);
      delete $.className;
      var K,
          X = {};
      return "undefined" != typeof window && (X.context = window), React__default.createElement(Paper, {
        elevation: this.options.elevation,
        ref: this.tableContent,
        className: U
      }, 0 < C.data.length && this.options.selectToolbarPlacement !== STP.NONE && React__default.createElement(z, {
        options: this.options,
        selectedRows: C,
        onRowsDelete: this.selectRowDelete,
        displayData: x,
        selectRowUpdate: this.selectRowUpdate,
        components: this.props.components
      }), (0 === C.data.length || -1 !== [STP.ABOVE, STP.NONE].indexOf(this.options.selectToolbarPlacement)) && M && React__default.createElement(H, {
        columns: v,
        columnOrder: D,
        displayData: x,
        data: g,
        filterData: w,
        filterList: T,
        filterUpdate: this.filterUpdate,
        updateFilterByType: this.updateFilterByType,
        options: this.options,
        resetFilters: this.resetFilters,
        searchText: I,
        searchTextUpdate: this.searchTextUpdate,
        searchClose: this.searchClose,
        tableRef: this.getTableContentRef,
        title: r,
        toggleViewColumn: this.toggleViewColumn,
        updateColumns: this.updateColumns,
        setTableAction: this.setTableAction,
        components: this.props.components
      }), React__default.createElement(O, {
        options: this.options,
        serverSideFilterList: this.props.options.serverSideFilterList,
        filterListRenderers: v.map(function (e) {
          return e.customFilterListOptions && e.customFilterListOptions.render ? e.customFilterListOptions.render : e.customFilterListRender ? e.customFilterListRender : function (e) {
            return e;
          };
        }),
        customFilterListUpdate: v.map(function (e) {
          return e.customFilterListOptions && e.customFilterListOptions.update ? e.customFilterListOptions.update : null;
        }),
        filterList: T,
        filterUpdate: this.filterUpdate,
        columnNames: W
      }), React__default.createElement("div", {
        style: _objectSpread2({
          position: "relative"
        }, V),
        className: e
      }, (!0 === this.options.resizableColumns || this.options.resizableColumns && this.options.resizableColumns.enabled) && React__default.createElement(F, {
        key: N,
        columnOrder: D,
        updateDividers: function updateDividers(e) {
          return t.updateDividers = e;
        },
        setResizeable: function setResizeable(e) {
          return t.setHeadResizeable = e;
        },
        options: this.props.options,
        tableId: this.options.tableId
      }), (K = React__default.createElement(MuiTable, _extends({
        ref: function ref(e) {
          return t.tableRef = e;
        },
        tabIndex: "0",
        role: "grid",
        className: G
      }, $), React__default.createElement("caption", {
        className: o.caption
      }, r), React__default.createElement(L, {
        columns: v,
        activeColumn: _,
        data: x,
        count: N,
        page: R,
        rowsPerPage: B,
        selectedRows: C,
        selectRowUpdate: t.selectRowUpdate,
        toggleSort: t.toggleSortColumn,
        setCellRef: t.setHeadCellRef,
        expandedRows: P,
        areAllRowsExpanded: t.areAllRowsExpanded,
        toggleAllExpandableRows: t.toggleAllExpandableRows,
        options: t.options,
        sortOrder: k,
        columnOrder: D,
        updateColumnOrder: t.updateColumnOrder,
        draggableHeadCellRefs: t.draggableHeadCellRefs,
        tableRef: t.getTableContentRef,
        tableId: t.options.tableId,
        timers: t.timers,
        components: t.props.components
      }), React__default.createElement(E, {
        data: x,
        count: N,
        columns: v,
        page: R,
        rowsPerPage: B,
        selectedRows: C,
        selectRowUpdate: t.selectRowUpdate,
        previousSelectedRow: S,
        expandedRows: P,
        toggleExpandRow: t.toggleExpandRow,
        options: t.options,
        columnOrder: D,
        filterList: T,
        components: t.props.components,
        tableId: t.options.tableId
      }), t.options.customTableBodyFooterRender ? t.options.customTableBodyFooterRender({
        data: x,
        count: N,
        columns: v,
        selectedRows: C,
        selectableRows: t.options.selectableRows
      }) : null), m ? React__default.createElement(reactDnd.DndProvider, _extends({
        backend: m
      }, X), K) : K)), React__default.createElement(A, {
        options: this.options,
        page: R,
        rowCount: N,
        rowsPerPage: B,
        changeRowsPerPage: this.changeRowsPerPage,
        changePage: this.changePage
      }), React__default.createElement("div", {
        className: o.liveAnnounce,
        "aria-live": "polite"
      }, y));
    }
  }]), a;
}();

_defineProperty(MUIDataTable, "defaultProps", {
  title: "",
  options: {},
  data: [],
  columns: [],
  components: {
    TableBody: DefaultTableBody,
    TableFilter: DefaultTableFilter,
    TableFilterList: TableFilterList,
    TableFooter: TableFooter,
    TableHead: TableHead,
    TableResize: DefaultTableResize,
    TableToolbar: DefaultTableToolbar,
    TableToolbarSelect: DefaultTableToolbarSelect,
    Tooltip: MuiTooltip
  }
});

var MUIDataTable$1 = styles.withStyles(defaultTableStyles, {
  name: "MUIDataTable"
})(MUIDataTable);

function debounce(o, n, r) {
  var i;
  return function () {
    var e = this,
        t = arguments,
        a = r && !i;
    clearTimeout(i), i = setTimeout(function () {
      i = null, r || o.apply(e, t);
    }, n), a && o.apply(e, t);
  };
}

var defaultStyles = function defaultStyles(e) {
  return {
    main: {
      display: "flex",
      flex: "1 0 auto"
    },
    searchIcon: {
      color: e.palette.text.secondary,
      marginTop: "10px",
      marginRight: "8px"
    },
    searchText: {
      flex: "0.8 0"
    },
    clearIcon: {
      "&:hover": {
        color: e.palette.error.main
      }
    }
  };
},
    _DebounceTableSearch = function () {
  _inherits(r, React__default.Component);

  var n = _createSuper(r);

  function r() {
    var t;

    _classCallCheck(this, r);

    for (var e = arguments.length, a = new Array(e), o = 0; o < e; o++) {
      a[o] = arguments[o];
    }

    return _defineProperty(_assertThisInitialized(t = n.call.apply(n, [this].concat(a))), "handleTextChangeWrapper", function (t) {
      return function (e) {
        t(e.target.value);
      };
    }), _defineProperty(_assertThisInitialized(t), "onKeyDown", function (e) {
      27 === e.keyCode && t.props.onHide();
    }), t;
  }

  return _createClass(r, [{
    key: "componentDidMount",
    value: function value() {
      document.addEventListener("keydown", this.onKeyDown, !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      document.removeEventListener("keydown", this.onKeyDown, !1);
    }
  }, {
    key: "render",
    value: function value() {
      var t = this,
          e = this.props,
          a = e.classes,
          o = e.options,
          n = e.onHide,
          r = e.searchText,
          i = debounce(function (e) {
        t.props.onSearch(e);
      }, e.debounceWait);
      return React__default.createElement(Grow, {
        appear: !0,
        in: !0,
        timeout: 300
      }, React__default.createElement("div", {
        className: a.main
      }, React__default.createElement(SearchIcon, {
        className: a.searchIcon
      }), React__default.createElement(TextField, _extends({
        className: a.searchText,
        autoFocus: !0,
        InputProps: {
          "data-test-id": o.textLabels.toolbar.search,
          "aria-label": o.textLabels.toolbar.search
        },
        defaultValue: r,
        onChange: this.handleTextChangeWrapper(i),
        fullWidth: !0,
        inputRef: function inputRef(e) {
          return t.searchField = e;
        },
        placeholder: o.searchPlaceholder
      }, o.searchProps ? o.searchProps : {})), React__default.createElement(IconButton, {
        className: a.clearIcon,
        onClick: n
      }, React__default.createElement(ClearIcon, null))));
    }
  }]), r;
}(),
    DebounceTableSearch = styles.withStyles(defaultStyles, {
  name: "MUIDataTableSearch"
})(_DebounceTableSearch);

function debounceSearchRender() {
  var n = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 200;
  return function (e, t, a, o) {
    return React__default.createElement(DebounceTableSearch, {
      searchText: e,
      onSearch: t,
      onHide: a,
      options: o,
      debounceWait: n
    });
  };
}

exports.DebounceTableSearch = DebounceTableSearch, exports.ExpandButton = ExpandButton, exports.Popover = Popover, exports.TableBody = DefaultTableBody, exports.TableBodyCell = TableBodyCell, exports.TableBodyRow = TableBodyRow$1, exports.TableFilter = DefaultTableFilter, exports.TableFilterList = TableFilterList, exports.TableFooter = TableFooter, exports.TableHead = TableHead, exports.TableHeadCell = TableHeadCell, exports.TableHeadRow = TableHeadRow, exports.TablePagination = TablePagination, exports.TableResize = DefaultTableResize, exports.TableSearch = TableSearch, exports.TableSelectCell = TableSelectCell$1, exports.TableToolbar = DefaultTableToolbar, exports.TableToolbarSelect = DefaultTableToolbarSelect, exports.TableViewCol = TableViewCol, exports.debounceSearchRender = debounceSearchRender, exports.default = MUIDataTable$1;